import {Controller} from "stimulus"
import $ from 'jquery';
import {setSessionVar, checkSessionVar, checkSessionVarWithData} from './sessionStorage_controller'
import {cancel_shopping_cart} from './wizard_controller'
import {get_popup} from './popup_controller'
import {set_locale} from './localize_controller'
import {get_review} from './review_controller'


import {preferences} from './preferences_controller'
import {catalog} from './catalogs_controller'
import Swal from 'sweetalert2/dist/sweetalert2'
import {blockBody, unblockBody} from './blockUI_controller'
import 'sweetalert2/dist/sweetalert2.css'
// import '@sweetalert2/theme-borderless/borderless.scss'
import 'slick-carousel/slick/slick.min'
import {create_array_for_product} from "./b2b_controller";


let notice_section = null;
let event_section = null;
let map_section_id = null;
let review_section_id = null;
let section_gallery = null;
let review_section = null;
let notice_html = [];
let event_html = [];

String.prototype.isEmpty = function () {
    return (this.length === 0 || !this.trim());
}

let notice_event = () => new Promise((resolve, reject) => {
    let event_html_result = ``;
    let event_control = document.getElementsByClassName('event-control');
    if (event_html.length > 0) {
        event_html.map((elem, index) => {
            switch (index % 4) {
                case 0:
                    let active = '';
                    if (index === 0) {
                        active = 'active';
                    } else {
                        event_html_result += `</div>`;
                    }
                    /*event_html_result += `<div class="carousel-pages" style="overflow: scroll; max-height: 65vh; padding: 3rem;">`;*/
                    event_html_result += `<div class="carousel-pages" style="overflow: scroll; max-height: 65vh; padding: 1.5rem 4rem; display: grid; grid-template-columns: repeat(auto-fit, minmax(540px, 1fr)); gap: 2rem; grid-auto-rows: 1fr; justify-content: center; align-items: center;">`;
                    event_html_result += elem;
                    break;
                default:
                    event_html_result += elem;
                    break
            }
        })

        if (event_html.length <= 4) {
            for (let i = 0; i < event_control.length; i++) {
                event_control[i].classList.add('ocultar');
            }
        }
    } else {
        if (document.getElementById('event_container') !== null) {
            document.getElementById('event_container').style.display = 'none';
        }
    }
    event_html_result += `    </div>
                        </div>`;

    let notice_html_result = ``;
    let notice_control = document.getElementsByClassName('notice-control');
    if (notice_html.length > 0) {
        notice_html.map((elem, index) => {
            switch (index % 4) {
                case 0:
                    let active = '';
                    if (index === 0) {
                        active = 'active';
                    } else {
                        notice_html_result += `</div>`;
                    }
                    /*notice_html_result += `<div class="carousel-pages" style="overflow: scroll; max-height: 65vh; padding: 3rem;">`;*/
                    notice_html_result += `<div class="carousel-pages" style="overflow: scroll; max-height: 65vh; padding: 1.5rem 4rem; display: grid; grid-template-columns: repeat(auto-fit, minmax(540px, 1fr)); gap: 2rem; grid-auto-rows: 1fr; justify-content: center; align-items: center;">`;
                    notice_html_result += elem;
                    break;
                default:
                    notice_html_result += elem;
                    break
            }
        })

        if (notice_html.length <= 4) {
            for (let i = 0; i < notice_control.length; i++) {
                notice_control[i].classList.add('ocultar');
            }
        }

    } else {
        if (document.getElementById('notice_container') !== null) {
            document.getElementById('notice_container').style.display = 'none';
        }
    }
    notice_html_result += `    </div>
                        </div>`;

    if (notice_section !== null) {
        notice_section.html(notice_html_result);
    }
    if (event_section !== null) {
        event_section.html(event_html_result);
    }

    resolve({next: true});
})

let review = (id) => new Promise((resolve, reject) => {
    get_review().then(
        respond => {
            let html = '';
            let count = 0;
            if (respond.length > 0) {
                respond.map(elem => {
                    let active = '';
                    if (count === 0) {
                        active = 'active';
                    }
                    html += `
                            <div class="carousel-item ${active}">
                              <div class="testimonial">
                                <div class="content">
                                  <span>&rdquo;</span>
                                  ${elem.review}
                                </div>
                                <div class="author">
                                  <div class="name">${elem.user}</div>
                                  <ul class="rating">`;
                    for (let i = 0; i < parseInt(elem.rating); i++) {
                        html += `<li><span class="fa fa-star"></span></li>`;
                    }
                    html += `     </ul>
                                </div>
                              </div>
                            </div>`;

                    count += 1;
                })
                document.getElementById(id).innerHTML = html;
            } else {
                if (document.getElementById(`to_section_${review_section_id}`) !== null) {
                    document.getElementById(`to_section_${review_section_id}`).style.display = 'none';
                }
                document.getElementById('review_pre').style.display = 'none';
            }
        }
    )
})

let aleatori_behavior = () => {
    // let myArray = ['backInLeft', 'backInRight', 'backInUp', 'bounceIn', 'bounceInLeft', 'bounceInRight', 'bounceInUp', 'fadeInLeftBig', 'fadeInRightBig', 'fadeInUpBig'];
    let myArray = ['backInUp', 'bounceIn', 'bounceInUp'];
    let rand = Math.floor(Math.random() * myArray.length);
    return myArray[rand];
}

require("select2/dist/css/select2")
require("select2-bootstrap-theme/dist/select2-bootstrap")

let prev = 0;
let next = 0;
let id_array_for_section_with_block = [];
let car_count_class = '';
let safari_count_class = '';
let rural_tourism_count_class = '';
let horseback_ride_count_class = '';
let events_count_class = '';
let excursion_count_class = '';

function animation_for_sections() {
    let controller = new ScrollMagic.Controller();

    let image_b_2 = document.getElementById('image_b_2');
    if (image_b_2 !== null) {
        new ScrollMagic.Scene({triggerElement: "#image_b_2", duration: 300})
            .addTo(controller)
            // .on("update", function (e) {
            //     $("#scrollDirection").text(e.target.controller().info("scrollDirection"));
            // })
            .on("enter", function (event) {
            })
            // .on("start end", function (e) {
            //     $("#lastHit").text(e.type == "start" ? "top" : "bottom");
            // })
            .on("progress", function (event) {
                image_b_2.style.top = `-${10 - (event.progress.toFixed(3) * 10)}%`;
            });
    }

    if (document.body.clientWidth > 650) {
        if (id_array_for_section_with_block.length > 0) {
            id_array_for_section_with_block.map(id => {
                let section_search_form = document.getElementById(`section_search_form_${id}`);
                if (section_search_form !== null) {
                    new ScrollMagic.Scene({triggerElement: `#block_sec_${id}`, duration: 500, offset: 100})
                        .setPin(`#section_search_form_${id}`)
                        .addTo(controller);
                }
            })
        }
    }
}

function gallery() {
    if (section_gallery !== null) {
        let section = `presentation_gallery_${section_gallery}`;
        let controls = `button_magic_masonry_${section_gallery}`;
        let cards = `section_${section_gallery}`;
        let gallery_html = '';

        //BUSCAMOS LOS ELEMENTOS A MOSTRAR
        $.ajax({
            url: `${location.origin}/${sessionStorage.getItem('locale')}/admin/media_galeries/gallery`,
            data: {},
            type: 'GET',
            success: function (data) {
                if (data.length > 0) {
                    data.map((elem, index) => {
                        switch (index % 9) {
                            case 0:
                                let active = '';
                                if (index === 0) {
                                    active = 'active';
                                } else {
                                    gallery_html += `    </div>
                                                    </div>`;
                                }
                                gallery_html += `<div class="carousel-item ${active}" data-interval="60000">
                                                    <div class="magic_grid">`;
                                gallery_html += `<div id="mc_${elem.id}" class="magic_card">
                                <img src="${elem.img}" alt="">
                                <div class="description">
                                  <p>
                                    ${elem.description}
                                  </p>
                                </div>
                                <div class="action">
                                  <a href="javascript:;" onclick="document.getElementById('mc_${elem.id}').classList.toggle('active')"></a>
                                </div>
                              </div>`;
                                break;
                            default:
                                gallery_html += `<div id="mc_${elem.id}" class="magic_card">
                                <img src="${elem.img}" alt="">
                                <div class="description">
                                  <p>
                                    ${elem.description}
                                  </p>
                                </div>
                                <div class="action">
                                  <a href="javascript:;" onclick="document.getElementById('mc_${elem.id}').classList.toggle('active')"></a>
                                </div>
                              </div>`;
                                break
                        }
                    })

                    if (data.length <= 9) {
                        if (document.getElementById(controls) !== null) {
                            document.getElementById(controls).style.display = 'none'
                        }
                    }

                    if (document.getElementById(cards) !== null) {
                        document.getElementById(cards).innerHTML = gallery_html;

                        // INICIALIZAMOS EL MAGICGRID PARA LOS MASONRY GRID
                        if (document.getElementsByClassName('magic_grid') !== null && document.getElementsByClassName('magic_grid').length > 0) {
                            let magicGrid = new MagicGrid({
                                container: '.magic_grid',
                                animate: true,
                                gutter: 15,
                                static: true,
                                useMin: true,
                                center: true
                            })
                            magicGrid.listen();
                        }
                    }
                } else {
                    if (document.getElementById(section) !== null) {
                        document.getElementById(section).style.display = 'none';
                    }
                }
            }
        })
    }
}

let checkReservation = async () => {
    if (sessionStorage.getItem('has_reservation') === 'true') {
        $('#show_reservation').css({'display': 'flex'});
    } else {
        $('#show_reservation').css({'display': 'none'});
    }
}

let save_data_pre_reservation = (obj) => new Promise((resolve, reject) => {
    $.ajax({
        url: location.origin + `/${sessionStorage.getItem('locale')}/admin/products/get_product_data`,
        data: {
            category: obj.dataset.categoryid
        },
        type: 'get',
        success: async (data) => {
            let category = await setSessionVar('category', data.data.code, 'add', false);
            let category_text = await setSessionVar('text_category', data.data.name, 'add', false);
            let day_delay = await setSessionVar('day_delay_rent', data.data.reservation_time, 'add', false);
            let day_min = await setSessionVar('day_min_rent', data.data.min_length_reservation, 'add', false);
            let day_max = await setSessionVar('day_max_rent', data.data.max_length_reservation, 'add', false);
            let description = await setSessionVar('category_description', data.data.description, 'add', false);
            let product = await setSessionVar('product_id', obj.dataset.id, 'add', false);
            let success = 0;
            let fail = 0;

            await [category, category_text, day_delay, day_min, day_max, description, product].map(elem => {
                if (elem.success) {
                    success = success + 1;
                } else {
                    fail = fail + 1;
                }
            })

            resolve({
                success: true,
                success_count: success,
                fail_count: fail

            })
        }
    })
})

let getSeller = async (text) => {
    let p = await preferences(text, 'api');
    setSessionVar('seller', p.value, 'add', false)
}

let cancelReservation = async () => {
    //Metodo por resolver
    /*
    { code: 200, success: true, status: "FAIL", amount: undefined }
setValue_controller.js:65
     */
    cancel_shopping_cart().then(
        async result => {
            if (result.code === 200 && result.success === true) {
                let response = await setSessionVar('', '', 'clear', false);

                if (response.success) {
                    set_locale().then(
                        locale => {
                            location.href = `/${locale.locale}/`;
                        })
                }
            }
        }
    )
}

let staticSection = (context) => new Promise((resolve, reject) => {
    let section_conatiner = $('#section_container');
    let footer_container = $('#footer_section');
    let html = '<div data-controller="word wowjs">';
    let section_show_html = $('#sections_show_navbar');
    let sections_show_in = '';
    let footer = '';
    $.ajax({
        url: `/${sessionStorage.getItem('locale')}/admin/sections/json`,
        data: {},
        type: "get",
        success: function (sections) {
            sections.map((section) => {
                if (section_conatiner[0] !== undefined) {
                    if (section.destination === 'body') {
                        if (section.show) {
                            sections_show_in += `<a id="to_section_${section.id}" class="a-link" href="#s_${section.id}" data-action="setValue#saltarA setValue#actionTrigger" data-target="#s_${section.id}">
                                                    ${section.name}
                                                  </a>`
                        }

                        let img = section.thumbnails || section.background_image;
                        let bg_image = section.background_image;
                        html += context.tpl_section(section.id, section.access_url, img, section.helpertext, section.name, section.descriptions, section.backgroud, section.typesection, section.has_divider_top, section.divider_top, section.has_divider_bottom, section.divider_bottom, bg_image);
                    }
                } else {
                    if (section.destination === 'body') {
                        if (section.show) {
                            sections_show_in += `<a id="to_section_${section.id}" class="a-link" href="/#s_${section.id}">
                                                    ${section.name}
                                                  </a>`
                        }
                    }
                }
                if (footer_container[0] !== undefined) {
                    if (section.destination === 'footer') {
                        footer += context.tpl_section_footer(section.id, section.access_url, section.name, section.typesection);
                    }
                }
            });

            if (section_show_html[0] !== undefined) {
                section_show_html.html(sections_show_in);
            }

            if (section_conatiner[0] !== undefined) {
                html += '</div>';
                section_conatiner[0].innerHTML = html;

                animation_for_sections();
                gallery();
            }

            if (footer_container[0] !== undefined) {
                footer_container.html(footer);
            }

            resolve({
                next: true
            })
        }
    })
});

let staticPage = (context) => new Promise((resolve, reject) => {
    $.ajax({
        url: `/${sessionStorage.getItem('locale')}/admin/pages/json`,
        data: {format: "json"},
        type: "get",
        success: function (pages) {
            let html = '';
            let count_notice = 0;
            let count_event = 0;
            pages.map((page) => {
                if (page.show) {
                    let url = '';
                    let section_body = $('#section_' + page.section.id);

                    if (page.isExternaUrl) {
                        url = page.access_url;
                    } else {
                        if (page.access_url === null || page.access_url === "" || page.access_url === undefined) {
                            url = 'javascript:;';
                        } else {
                            url = location.origin + `/${sessionStorage.getItem('locale')}/pages/ver/` + page.access_url;
                        }
                    }

                    let image = ''
                    let icon = '';
                    let description = '';

                    // EDITAR EL COMPORTAMIENTO DEL ICONO EN TODAS LAS PAGINAS
                    if (!page.icon.isEmpty()) {
                        if (page.icon.includes('fa-')) {
                            icon = `<span class="fa ${page.icon}"></span>`;
                        } else {
                            if (page.icon.includes('icon-')) {
                                icon = `<span class="${page.icon}"></span>`;
                            } else {
                                /*icon = `<img src="${page.icon}" alt="" class=''>`;*/
                                icon = `<img src='${page.icon}' alt='${page.name}' class='${(page.section.destination !== 'footer') ? 'w-100' : ''} img-fluid' style='max-width: 100%; max-height: 100%; object-fit: contain;'>`;
                            }
                        }
                    }

                    if (page.section.destination === 'body') {
                        if (page.has_thumbnails) {
                            image = page.thumbnails
                        } else if (page.has_image) {
                                image = page.background_image
                        } else {
                            image = page.thumbnails
                        }

                        if (page.short_description !== null) {
                            description = page.short_description;
                        }

                        if (section_body !== undefined) {
                            if (page.section.typesection === 'presentation-notice-more-events') {
                                notice_section = $('#notice_page_' + page.section.id);
                                event_section = $('#event_page_' + page.section.id);

                                if (page.tipo === 'notice') {
                                    notice_html.push(context.tpl_page(page.id, url, page.isExternaUrl, page.name, description, page.section.typesection, image, icon, count_notice, page.has_divider_top, page.divider_top, page.has_divider_bottom, page.divider_bottom, page.show_more_page));
                                    count_notice += 1;
                                }
                                if (page.tipo === 'event') {
                                    event_html.push(context.tpl_page(page.id, url, page.isExternaUrl, page.name, description, page.section.typesection, image, icon, count_event, page.has_divider_top, page.divider_top, page.has_divider_bottom, page.divider_bottom, page.show_more_page));
                                    count_event += 1;
                                }
                            } else {
                                section_body.append(context.tpl_page(page.id, url, page.isExternaUrl, page.name, description, page.section.typesection, image, icon, 0, page.has_divider_top, page.divider_top, page.has_divider_bottom, page.divider_bottom, page.show_more_page));
                            }
                        }
                    }

                    if (page.section.destination === 'footer') {
                        if (section_body !== undefined) {
                            section_body.append(context.tpl_page_footer(page.id, url, page.isExternaUrl, page.name, icon, page.show_more_page));
                        }
                    }
                }
            })

            resolve({
                next: true
            });
        }
    })
})


export default class extends Controller {
    initialize() {
        $.ajax({
            url: `${location.origin}/${sessionStorage.getItem('locale')}/config/count-product`,
            data: {},
            type: 'GET',
            success: function (data) {
                if (data['car'] !== undefined && parseInt(data['car']) > 0) {
                    /*car_count_class = 'ocultar';*/
                    car_count_class = '';
                }
                /*if (data['horseback_ride'] === undefined || parseInt(data['horseback_ride']) <= 0) {
                    horseback_ride_count_class = 'ocultar';
                }
                if (data['excursion'] === undefined || parseInt(data['excursion']) <= 0) {
                    excursion_count_class = 'ocultar';
                }
                if (data['safari'] === undefined || parseInt(data['safari']) <= 0) {
                    safari_count_class = 'ocultar';
                }
                if (data['events'] === undefined || parseInt(data['events']) <= 0) {
                    events_count_class = 'ocultar';
                }
                if (data['rural_tourism'] === undefined || parseInt(data['rural_tourism']) <= 0) {
                    rural_tourism_count_class = 'ocultar';
                }*/
                if (data['horseback_ride'] !== undefined && parseInt(data['horseback_ride']) > 0) {
                    horseback_ride_count_class = 'mostrar';
                }
                if (data['excursion'] !== undefined && parseInt(data['excursion']) > 0) {
                    excursion_count_class = 'mostrar';
                }
                if (data['safari'] !== undefined && parseInt(data['safari']) > 0) {
                    safari_count_class = 'mostrar';
                }
                if (data['events'] !== undefined && parseInt(data['events']) > 0) {
                    events_count_class = 'mostrar';
                }
                if (data['rural_tourism'] !== undefined && parseInt(data['rural_tourism']) > 0) {
                    rural_tourism_count_class = 'mostrar';
                }
            }
        });

        set_locale().then(
            locale => {
                // const btn_assistant_line = $('#btn_assistant_line');
                // if (location.pathname.includes('help_me')) {
                //     btn_assistant_line[0].style.display = 'none';
                // }
                if (sessionStorage.hasOwnProperty('need_clean')) {
                    if (sessionStorage.getItem('need_clean') === "true" && sessionStorage.getItem('inPayProccess') === "true" && location.pathname.includes("/payment/return")) {
                        setSessionVar('', '', 'clear', false);
                    }
                }

                //Disabled input
                $('#date_collect').attr('disabled', true);
                $('#time_collect').attr('disabled', true);
                $('#date_delivery').attr('disabled', true);
                $('#time_delivery').attr('disabled', true);

                getSeller('c2e_api_key');
                checkReservation().then();

                let container = $('#catalogo_container');
                if (container !== undefined && (location.pathname === `/${locale.locale}` || location.pathname === `/`)) {
                    preferences('show_catalog', 'modules').then(
                        showCatalog => {
                            if (showCatalog.active)
                                catalog().then(
                                    catalogo => {
                                        preferences('show_form_in_catalog', 'modules').then(
                                            showFormInCatalog => {
                                                let html = '';
                                                if (catalogo.success) {
                                                    let data = catalogo.data;

                                                    data.map(product => {
                                                        html += this.tpl_catalog(product.id, product.category, product.category_id, product.picture, product.price, product.description, showFormInCatalog.active);
                                                    })
                                                }

                                                container.html(html);
                                            }
                                        );
                                    }
                                )
                        })
                }

                const context = this;
                staticSection(context).then(
                    result => {
                        if (result.next) {
                            if (review_section !== null) {
                                review(review_section).then(
                                    review => {
                                        console.log(review);
                                    }
                                );
                            }

                            staticPage(context).then(
                                page_result => {
                                    if (page_result.next) {

                                        notice_event().then(
                                            notice_event_result => {
                                                unblockBody();
                                            }
                                        );
                                    }
                                }
                            )
                        }
                    }
                )
            })
    }

    connect() {
        setTimeout(function () {
            // Obtener el hash actual
            const hash = window.location.hash;

            if (hash) {
                // Obtener el elemento con ese ID
                const elemento = document.getElementById(hash.substring(1)); // substring(1) elimina el #

                // Si existe el elemento, hacer scroll suave hacia él
                if (elemento) {
                    elemento.scrollIntoView({
                        behavior: 'smooth',
                        block: 'start'
                    });
                }
            }
        }, 2000)
    }

    prev(e) {
        let element = e.target.dataset.target;
        if (prev < 0) {
            next -= (window.innerWidth - 20);
            prev += (window.innerWidth - 10);
            $('#' + element)[0].style.left = `${prev}px`;
        }
    }

    next(e) {
        next += (window.innerWidth - 20);
        prev -= (window.innerWidth - 10);
        let element = e.target.dataset.target;
        $('#' + element)[0].style.left = `${-next}px`;
    }

    setSessionKey(e) {
        setSessionVar(e.target.dataset.name, e.target.value, 'add', e.target.dataset.isdate).then(
            data => {
                create_array_for_product(e.target.dataset.name, e.target.value, 'add');
            }
        );
    }

    tpl_section(id, url, picture, helpertext, name, description, background, type, has_divider_top = false, divider_top = '', has_divider_bottom = false, divider_bottom = '', bg_image = '') {
        let dt = '';
        let db = '';
        let margin_y = 'margin-y-no-divider';

        let html = `<section id="s_${id}"><div class="row no-print ${background}">`;
        switch (type) {
            case 'presentation-with-many-image-and-form':
                id_array_for_section_with_block.push(id);
                html += `
                 <div class="initial-section">
                   <div class="section-container">
                     <div class="block_primary">
                       <div class="section-information">
                         <div class="section-information-title">
                           <h1>
                             ${name}
                           </h1>
                           <p>${helpertext}</p>
                         </div>
                         <div class="section-information-button">
                           <a href="javascript:;" class="decoration_none" data-action="setValue#saltarA" data-target="#block_sec_${id}">
                             <span data-target="#block_sec_${id}">
                               ${I18n.t('main.body.catalog.rent_btn')}
                             </span>
                           </a>
                         </div>
                       </div>
                       <div class="section-image">
                         <div class="section-image-background" style="--pict: url(${picture})">
                         </div>
                         <div class="section-image-overlay" style="--overl: url(${divider_top})">
                         </div>
                       </div>
                     </div>
                     <div id="block_sec_${id}" class="block-secondary">
                       <div class="section-bottom-image">
                         <div id="image_b_2" class="section-bottom-image-background image-parallax-efect" style="--pict-two: url(${bg_image})">
                         </div>
                         <div class="section-bottom-image-overlay" style="--overl-two: url(${divider_bottom})">
                         </div>
                       </div>
                       <div id="section_search_form_${id}" class="section-form">
                         <div id="box-form" class="box-form" data-controller="preferences">
                           <!-- TAB PARA EL HEADER DEL FORM -->
                           <ul class="nav nav-tabs" id="home_form" role="tablist">
                             <li class="nav-item ${car_count_class}" role="presentation">
                               <button class="nav-link active button_with_svg_icon" id="car-tab" data-toggle="tab" data-target="#car" data-form-type="car" data-action="preferences#set_form_type" type="button" role="tab" aria-controls="car" aria-selected="true">
                                 <svg width="800px" height="800px" viewBox="0 0 1024 1024" class="icon"  version="1.1" xmlns="http://www.w3.org/2000/svg"><path d="M1001 695.3H121c-50.8 0-92-41.2-92-92v-156c0-41.1 36.5-72.5 77.1-66.4l43.6 6.5 127.4-99.1c23.1-18 51.5-27.7 80.7-27.7h168c30.1 0 59.2 10.3 82.6 29.2l120.8 97.6s227.9 15.1 271.7 126.8v181.1z" fill="#C1E7D8" /><path d="M1001 704.3H121c-55.7 0-101-45.3-101-101v-156c0-22.2 9.6-43.2 26.5-57.7s39-20.9 61-17.6l39.8 6 124.3-96.7c24.5-19.1 55.2-29.6 86.2-29.6h168c32 0 63.4 11.1 88.3 31.2l118.6 95.8c12.5 1 63 5.9 118.4 21.6 37.1 10.5 68.6 23.8 93.6 39.4 32.1 20 53.8 44 64.5 71.3 0.4 1 0.6 2.2 0.6 3.3v181.1c0.2 4.9-3.8 8.9-8.8 8.9zM96.1 389.1c-13.8 0-27.3 4.9-37.9 14.1C45.4 414.3 38 430.3 38 447.3v156c0 45.8 37.3 83 83 83h871V516c-42.8-103.8-261.1-119.4-263.3-119.5-1.9-0.1-3.6-0.8-5.1-2l-120.8-97.6c-21.7-17.5-49-27.2-77-27.2h-168c-27.1 0-53.8 9.2-75.2 25.8l-127.4 99.1a8.89 8.89 0 0 1-6.9 1.8l-43.6-6.5c-2.8-0.6-5.7-0.8-8.6-0.8z" fill="#3E4152" /><path d="M255.4 665.1m-108.7 0a108.7 108.7 0 1 0 217.4 0 108.7 108.7 0 1 0-217.4 0Z" fill="#8599A4" /><path d="M255.4 782.8c-64.9 0-117.7-52.8-117.7-117.7s52.8-117.7 117.7-117.7 117.7 52.8 117.7 117.7-52.8 117.7-117.7 117.7z m0-217.3c-55 0-99.7 44.7-99.7 99.7s44.7 99.7 99.7 99.7 99.7-44.7 99.7-99.7-44.7-99.7-99.7-99.7z" fill="#3E4152" /><path d="M753.5 665.1m-108.7 0a108.7 108.7 0 1 0 217.4 0 108.7 108.7 0 1 0-217.4 0Z" fill="#8599A4" /><path d="M753.5 782.8c-64.9 0-117.7-52.8-117.7-117.7s52.8-117.7 117.7-117.7 117.7 52.8 117.7 117.7-52.8 117.7-117.7 117.7z m0-217.3c-55 0-99.7 44.7-99.7 99.7s44.7 99.7 99.7 99.7 99.7-44.7 99.7-99.7c-0.1-55-44.8-99.7-99.7-99.7z" fill="#3E4152" /><path d="M596.5 478H300.7V375.3H515z" fill="#9B5C77" /><path d="M596.5 487H300.7c-5 0-9-4-9-9V375.3c0-5 4-9 9-9H515c2.7 0 5.3 1.3 7 3.4l81.5 102.6c2.1 2.7 2.6 6.4 1.1 9.5-1.5 3.2-4.6 5.2-8.1 5.2z m-286.8-18h268.2l-67.2-84.6h-201V469z" fill="#3E4152" /></svg>
                                 <p class="d-none d-md-inline">Suv Urban</p>
                               </button>
                             </li>
                             <li class="nav-item ocultar ${safari_count_class}" role="presentation">
                               <button class="nav-link button_with_svg_icon" id="safari-tab" data-toggle="tab" data-target="#safari" data-form-type="safari" data-action="preferences#set_form_type" type="button" role="tab" aria-controls="home" aria-selected="true">
                                 <svg height="200px" width="200px" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 512 512" xml:space="preserve" fill="#000000"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <path style="fill:#696B6F;" d="M83.478,272.696H16.696C7.475,272.696,0,265.221,0,256v-83.478h50.087 c27.662,0,50.087,22.424,50.087,50.087V256C100.174,265.221,92.699,272.696,83.478,272.696z"></path> <path style="fill:#616267;" d="M294.957,272.696c-9.217,0-16.696-7.473-16.696-16.696V55.652c0-9.223,7.479-16.696,16.696-16.696 c9.217,0,16.696,7.473,16.696,16.696V256C311.652,265.223,304.174,272.696,294.957,272.696z"></path> <path style="fill:#696B6F;" d="M16.696,272.696C7.479,272.696,0,265.223,0,256V86.565c0-9.223,7.479-16.696,16.696-16.696 s16.696,7.473,16.696,16.696V256C33.391,265.223,25.913,272.696,16.696,272.696z"></path> <path style="fill:#616267;" d="M294.957,172.522c-4.272,0-8.544-1.631-11.804-4.892c-6.521-6.516-6.521-17.092,0-23.609 L383.327,43.847c6.521-6.521,17.087-6.521,23.609,0c6.521,6.516,6.521,17.092,0,23.609L306.761,167.63 C303.5,170.891,299.228,172.522,294.957,172.522z"></path> <path style="fill:#957856;" d="M428.522,38.957H294.957H116.87H47.608C21.358,38.957,0,60.315,0,86.565 c0,9.223,7.479,16.696,16.696,16.696s16.696-7.473,16.696-16.696c0-7.837,6.38-14.217,14.217-14.217h69.261h178.087h133.565 c9.217,0,16.696-7.473,16.696-16.696S437.739,38.957,428.522,38.957z"></path> <path style="fill:#816952;" d="M428.522,38.957H294.957H256v33.391h38.957h133.565c9.217,0,16.696-7.473,16.696-16.696 S437.739,38.957,428.522,38.957z"></path> <path style="fill:#B7B9C4;" d="M395.142,272.701c-6.125,0-12.016-3.386-14.946-9.234l-33.391-66.783 c-4.119-8.25-0.777-18.277,7.467-22.402c8.239-4.114,18.277-0.782,22.402,7.467l33.391,66.783c4.119,8.25,0.777,18.277-7.467,22.402 C400.201,272.13,397.653,272.701,395.142,272.701z"></path> <path style="fill:#816952;" d="M495.304,406.261h-33.391c-9.223,0-16.696-7.473-16.696-16.696s7.473-16.696,16.696-16.696h33.391 c9.217,0,16.696,7.473,16.696,16.696S504.521,406.261,495.304,406.261z"></path> <path style="fill:#696B6F;" d="M217.043,272.696h-66.783c-9.223,0-16.696-7.473-16.696-16.696v-66.783 c0-9.223,7.473-16.696,16.696-16.696h33.391c27.619,0,50.087,22.468,50.087,50.087V256 C233.739,265.223,226.266,272.696,217.043,272.696z"></path> <path style="fill:#E6C892;" d="M395.13,239.304H0v150.261c0,9.22,7.475,16.696,16.696,16.696h461.913v-83.478 C478.609,276.679,441.234,239.304,395.13,239.304z"></path> <path style="fill:#D8B68A;" d="M395.13,239.304H256v166.957h222.609v-83.478C478.609,276.678,441.234,239.304,395.13,239.304z"></path> <path style="fill:#957856;" d="M239.304,339.478h-33.391c-9.223,0-16.696-7.473-16.696-16.696s7.473-16.696,16.696-16.696h33.391 c9.223,0,16.696,7.473,16.696,16.696S248.527,339.478,239.304,339.478z"></path> <path style="fill:#696B6F;" d="M100.174,473.044c-36.826,0-66.783-29.956-66.783-66.783s29.956-66.783,66.783-66.783 s66.783,29.956,66.783,66.783S137,473.044,100.174,473.044z"></path> <path style="fill:#616267;" d="M166.957,406.261c0-36.826-29.956-66.783-66.783-66.783v133.565 C137,473.044,166.957,443.087,166.957,406.261z"></path> <path style="fill:#E7ECFD;" d="M100.174,372.87c-18.413,0-33.391,14.978-33.391,33.391s14.978,33.391,33.391,33.391 s33.391-14.978,33.391-33.391S118.587,372.87,100.174,372.87z"></path> <path style="fill:#DAE0F0;" d="M133.565,406.261c0-18.413-14.978-33.391-33.391-33.391v66.783 C118.587,439.652,133.565,424.674,133.565,406.261z"></path> <path style="fill:#696B6F;" d="M378.435,473.044c-36.826,0-66.783-29.956-66.783-66.783s29.956-66.783,66.783-66.783 s66.783,29.956,66.783,66.783S415.261,473.044,378.435,473.044z"></path> <path style="fill:#616267;" d="M445.217,406.261c0-36.826-29.956-66.783-66.783-66.783v133.565 C415.261,473.044,445.217,443.087,445.217,406.261z"></path> <path style="fill:#E7ECFD;" d="M378.435,372.87c-18.413,0-33.391,14.978-33.391,33.391s14.978,33.391,33.391,33.391 c18.413,0,33.391-14.978,33.391-33.391S396.848,372.87,378.435,372.87z"></path> <path style="fill:#DAE0F0;" d="M411.826,406.261c0-18.413-14.978-33.391-33.391-33.391v66.783 C396.848,439.652,411.826,424.674,411.826,406.261z"></path> </g></svg>
                                 <p class="d-none d-md-inline">Safari</p>
                               </button>
                             </li>
                             <li class="nav-item ocultar ${excursion_count_class}" role="presentation">
                               <button class="nav-link button_with_svg_icon" id="home-tab" data-toggle="tab" data-target="#excursiones" data-form-type="excursion" data-action="preferences#set_form_type" type="button" role="tab" aria-controls="home" aria-selected="true">
                                 <svg viewBox="0 0 72 72" id="emoji" xmlns="http://www.w3.org/2000/svg" fill="#000000"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g id="color"> <rect x="22.0868" y="36.0991" width="45.2778" height="12.0246" fill="#b1cc33"></rect> <rect x="34.9185" y="32.7702" rx="1.0578" ry="1.0578" width="6.3408" height="10.6464" fill="#92d3f5"></rect> <rect x="21.9628" y="32.7702" rx="1.0578" ry="1.0578" width="6.3408" height="10.6464" fill="#92d3f5"></rect> <rect x="47.9287" y="32.7702" rx="1.0578" ry="1.0578" width="6.3408" height="10.6464" fill="#92d3f5"></rect> <rect x="60.9389" y="32.7702" rx="1.0578" ry="1.0578" width="6.3408" height="10.6464" fill="#92d3f5"></rect> <path fill="#d0cfce" d="M34.31,51.6463a4.2445,4.2445,0,1,1-8.4889,0"></path> <path fill="#d0cfce" d="M63.2766,51.6463a4.2445,4.2445,0,0,1-8.489,0"></path> <polygon fill="#92d3f5" points="16 22 21 17 26 22 24 23 22 21 20 23 18 22 15 24 14 23 16 22"></polygon> <polygon fill="#92d3f5" points="42.167 15.429 50.083 9 58 15.429 54.833 16.714 51.667 14.143 48.5 16.714 45.333 15.429 40.583 18 39 16.714 42.167 15.429"></polygon> <rect x="22.7567" y="47.5836" width="43.9381" height="4.0628" fill="#3f3f3f"></rect> </g> <g id="line"> <line x1="4" x2="68" y1="56" y2="56" stroke="#000000" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"></line> <polyline fill="none" stroke="#000000" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" points="68 22 50 9 29 24 21 16 4 32"></polyline> <path fill="none" stroke="#000000" stroke-linecap="round" stroke-miterlimit="10" stroke-width="2.0737" d="M23.71,50.6463H22.89a.8909.8909,0,0,1-.8884-.8883V28.8236a1.9023,1.9023,0,0,1,1.8967-1.8967H65.383A1.9023,1.9023,0,0,1,67.28,28.8236V49.7583a.8906.8906,0,0,1-.888.888h-.8291"></path> <line x1="52.532" x2="36.4059" y1="50.6463" y2="50.6463" fill="none" stroke="#000000" stroke-linecap="round" stroke-miterlimit="10" stroke-width="2.0737"></line> <path fill="none" stroke="#000000" stroke-linecap="round" stroke-miterlimit="10" stroke-width="2.0737" d="M34.31,51.8984a4.2445,4.2445,0,1,1-8.4889,0"></path> <path fill="none" stroke="#000000" stroke-linecap="round" stroke-miterlimit="10" stroke-width="2.0737" d="M63.2766,51.6463a4.2445,4.2445,0,0,1-8.489,0"></path> <rect x="34.9185" y="32.7804" rx="1.0578" ry="1.0578" width="6.3408" height="10.6464" fill="none" stroke="#000000" stroke-linecap="round" stroke-miterlimit="10" stroke-width="2.0737"></rect> <rect x="21.9628" y="32.7804" rx="1.0578" ry="1.0578" width="6.3408" height="10.6464" fill="none" stroke="#000000" stroke-linecap="round" stroke-miterlimit="10" stroke-width="2.0737"></rect> <rect x="47.7568" y="32.8587" rx="1.0578" ry="1.0578" width="6.3408" height="10.6464" fill="none" stroke="#000000" stroke-linecap="round" stroke-miterlimit="10" stroke-width="2.0737"></rect> <rect x="60.9389" y="32.8587" rx="1.0578" ry="1.0578" width="6.3408" height="10.6464" fill="none" stroke="#000000" stroke-linecap="round" stroke-miterlimit="10" stroke-width="2.0737"></rect> <line x1="20.9448" x2="68.3129" y1="47.5655" y2="47.5655" fill="none" stroke="#000000" stroke-linecap="round" stroke-miterlimit="10" stroke-width="1.9699"></line> </g> </g></svg>   
                                 <p class="d-none d-md-inline">Excursiones</p>
                               </button>
                             </li>
                             <li class="nav-item ocultar ${rural_tourism_count_class}" role="presentation">
                               <button class="nav-link button_with_svg_icon" id="home-tab" data-toggle="tab" data-target="#rural_tourism" data-form-type="rural_tourism" data-action="preferences#set_form_type" type="button" role="tab" aria-controls="home" aria-selected="true">
                                 <svg height="200px" width="200px" version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" viewBox="0 0 512 512" xml:space="preserve" fill="#000000"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <circle style="fill:#4DE1FF;" cx="256" cy="256" r="247.83"></circle> <path style="fill:#C4F5FF;" d="M322.791,109.688c-3.9,0-7.688,0.477-11.312,1.37C305.16,86.31,282.718,68.01,256,68.01 s-49.16,18.3-55.479,43.048c-3.624-0.893-7.412-1.37-11.312-1.37c-26.015,0-47.105,21.09-47.105,47.105h227.793 C369.896,130.778,348.807,109.688,322.791,109.688z"></path> <path style="fill:#7FB21E;" d="M42.32,281.13C54.768,388.111,145.679,471.149,256,471.149s201.232-83.038,213.68-190.018H42.32z"></path> <g> <path style="fill:#FFFFFF;" d="M225.91,175.222c0-17.139-13.894-31.032-31.032-31.032c-2.569,0-5.064,0.315-7.452,0.903 c-4.164-16.303-18.947-28.359-36.548-28.359s-32.386,12.056-36.548,28.359c-2.388-0.588-4.883-0.903-7.452-0.903 c-17.139,0-31.032,13.894-31.032,31.032L225.91,175.222L225.91,175.222z"></path> <path style="fill:#FFFFFF;" d="M409.018,189.761c-3.235,0-6.378,0.395-9.385,1.137c-5.243-20.532-23.861-35.714-46.027-35.714 s-40.784,15.182-46.027,35.714c-3.007-0.741-6.149-1.137-9.385-1.137c-21.582,0-39.08,17.496-39.08,39.08h188.982 C448.098,207.258,430.602,189.761,409.018,189.761z"></path> </g> <g> <path style="fill:#03242B;" d="M437.019,74.981C388.667,26.628,324.38,0,256,0S123.333,26.628,74.981,74.981 C26.628,123.332,0,187.62,0,256s26.628,132.668,74.981,181.019C123.333,485.372,187.62,512,256,512s132.667-26.628,181.019-74.981 C485.372,388.668,512,324.38,512,256S485.372,123.332,437.019,74.981z M256,495.66c-132.149,0-239.66-107.51-239.66-239.66 S123.851,16.34,256,16.34S495.66,123.851,495.66,256S388.149,495.66,256,495.66z"></path> <path style="fill:#03242B;" d="M475.777,275.699c-1.55-1.742-3.771-2.739-6.104-2.739h-76.421v-2.723c0-4.512-3.657-8.17-8.17-8.17 c-4.513,0-8.17,3.658-8.17,8.17v2.723H232.017v-2.723c0-4.512-3.657-8.17-8.17-8.17s-8.17,3.658-8.17,8.17v2.723h-47.908v-2.723 c0-4.512-3.657-8.17-8.17-8.17s-8.17,3.658-8.17,8.17v2.723H42.326c-2.332,0-4.554,0.997-6.104,2.739 c-1.55,1.742-2.283,4.063-2.012,6.379c6.303,53.93,32.185,103.722,72.879,140.207c41.024,36.779,93.907,57.034,148.91,57.034 c49.283,0,96.048-15.814,135.239-45.734c3.587-2.739,4.275-7.865,1.536-11.452c-2.738-3.586-7.866-4.275-11.451-1.536 c-36.318,27.726-79.654,42.382-125.323,42.382c-101.925,0-188.174-74.031-204.289-173.678H460.28 c-6.741,41.209-26.229,80.108-55.467,110.385c-3.134,3.245-3.044,8.419,0.203,11.553c3.246,3.134,8.42,3.045,11.553-0.202 c33.857-35.061,55.599-80.86,61.22-128.958C478.06,279.762,477.327,277.442,475.777,275.699z"></path> <path style="fill:#03242B;" d="M312.664,346.492v10.894c0,4.512,3.657,8.17,8.17,8.17c4.513,0,8.17-3.658,8.17-8.17v-10.894 c0-4.512-3.657-8.17-8.17-8.17C316.321,338.322,312.664,341.98,312.664,346.492z"></path> <path style="fill:#03242B;" d="M279.983,313.811v10.894c0,4.512,3.657,8.17,8.17,8.17c4.513,0,8.17-3.658,8.17-8.17v-10.894 c0-4.512-3.657-8.17-8.17-8.17C283.64,305.641,279.983,309.299,279.983,313.811z"></path> <path style="fill:#03242B;" d="M376.912,313.811v10.894c0,4.512,3.657,8.17,8.17,8.17c4.513,0,8.17-3.658,8.17-8.17v-10.894 c0-4.512-3.657-8.17-8.17-8.17C380.569,305.641,376.912,309.299,376.912,313.811z"></path> <path style="fill:#03242B;" d="M118.748,313.811v10.894c0,4.512,3.657,8.17,8.17,8.17s8.17-3.658,8.17-8.17v-10.894 c0-4.512-3.657-8.17-8.17-8.17S118.748,309.299,118.748,313.811z"></path> <path style="fill:#03242B;" d="M75.844,183.392H225.91c4.513,0,8.17-3.658,8.17-8.17c0-21.616-17.587-39.202-39.202-39.202 c-0.647,0-1.293,0.016-1.938,0.048c-7.193-16.501-23.579-27.504-42.062-27.504s-34.87,11.004-42.062,27.504 c-0.646-0.032-1.292-0.048-1.938-0.048c-21.616,0-39.202,17.587-39.202,39.202C67.673,179.734,71.33,183.392,75.844,183.392z M106.875,152.359c1.856,0,3.705,0.224,5.496,0.666c4.349,1.075,8.763-1.564,9.873-5.911c3.34-13.078,15.114-22.211,28.633-22.211 c13.519,0,25.293,9.133,28.633,22.211c1.11,4.347,5.519,6.986,9.873,5.911c1.791-0.441,3.64-0.666,5.496-0.666 c9.729,0,18.058,6.108,21.354,14.691H85.523C88.817,158.467,97.147,152.359,106.875,152.359z"></path> <path style="fill:#03242B;" d="M199.309,113.774c4.25,1.514,8.923-0.707,10.436-4.959C216.688,89.296,235.277,76.18,256,76.18 c22.456,0,42.015,15.174,47.563,36.9c1.11,4.347,5.518,6.987,9.872,5.911c3.05-0.752,6.198-1.133,9.358-1.133 c9.96,0,19.442,3.769,26.698,10.613c1.577,1.489,3.593,2.227,5.605,2.227c2.171,0,4.337-0.861,5.945-2.564 c3.096-3.283,2.945-8.453-0.339-11.549c-10.301-9.715-23.763-15.066-37.909-15.066c-1.903,0-3.803,0.098-5.693,0.292 C307.515,76.761,283.372,59.84,256,59.84c-27.62,0-52.395,17.481-61.651,43.498C192.838,107.59,195.058,112.262,199.309,113.774z"></path> <path style="fill:#03242B;" d="M302.004,181.744c-1.266-0.102-2.536-0.154-3.808-0.154c-26.054,0-47.25,21.196-47.25,47.25 c0,4.512,3.657,8.17,8.17,8.17h107.837c4.513,0,8.17-3.658,8.17-8.17c0-4.512-3.657-8.17-8.17-8.17h-98.571 c3.593-13.091,15.598-22.739,29.814-22.739c2.509,0,5.008,0.303,7.427,0.9c4.351,1.076,8.763-1.564,9.873-5.911 c4.446-17.408,20.117-29.565,38.11-29.565s33.666,12.157,38.111,29.565c1.11,4.347,5.52,6.986,9.873,5.911 c2.421-0.597,4.92-0.9,7.427-0.9c14.216,0,26.221,9.647,29.814,22.739h-39.197c-4.513,0-8.17,3.658-8.17,8.17 c0,4.512,3.657,8.17,8.17,8.17h48.464c4.513,0,8.17-3.658,8.17-8.17c0-26.054-21.197-47.25-47.25-47.25 c-1.272,0-2.543,0.051-3.808,0.154c-8.406-20.772-28.673-34.73-51.603-34.73C330.678,147.015,310.409,160.972,302.004,181.744z"></path> </g> </g></svg>   
                                 <p class="d-none d-md-inline">Turismo Rural</p>
                               </button>
                             </li>
                             <li class="nav-item ocultar ${horseback_ride_count_class}" role="presentation">
                               <button class="nav-link button_with_svg_icon" id="home-tab" data-toggle="tab" data-target="#horseback_ride" data-form-type="horseback_ride" data-action="preferences#set_form_type" type="button" role="tab" aria-controls="home" aria-selected="true">
                                 <svg viewBox="0 0 72 72" id="emoji" xmlns="http://www.w3.org/2000/svg" fill="#000000"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <g id="color"> <path fill="#A57939" stroke="none" d="M54,49c-1-2,4-5,4-8c0-1.6006-1-6-5-7c-1.7246-0.4316-3.9814-1.4424-6.166-1.3135 C37.3125,33.25,31.625,35.625,28,34.6875c-0.9687-0.25-8.8125-8-9.375-8.6875l-3.5-3.4062l-0.4609,3.6977 C11.4971,28.4165,11,30,6,34c-0.5527,0.4424,1.3145,2.1719,2,2c4-1,8-1,8-1s1.8975,6.1826,2,8c0.1133,1.9971,0,6,1,7 c1.5811,1.5811,3,2,3,2s-2,4-3,6c-0.6328,1.2646-0.3535,2.6465,0,3c2,2,8,4,8,4l1-3c0,0-5-2-5-3c0-1.1289,4-4,5-6 c0,0,6.5596-0.4023,9-1c1.6895-0.4141,7.0381-2.7969,10.6133-4.4316c1.7812,2.58,4.1777,5.7099,4.1777,6.4316l-4,5l2,1c0,0,5-4,6-5 c0.3535-0.3535,0.1914-1.5381,0-2C55.25,51.6934,54.6328,50.2646,54,49z"></path> <path fill="#6A462F" stroke="none" d="M48,49c0,0-2.1426,6.7891-3,9c-0.8906,2.2959-2,8-2,8l4.167-1.167l2.417-4.917l-1.25-0.166v-2.584 l2.916-3.041"></path> <path fill="#6A462F" stroke="none" d="M56,35c0,0-1,0,2,0s7,3,6,7c-0.7275,2.9102-4.126,5.583,0.874,10.583c0,0,0.709,2.834-2.041,2.042 c0,0-2.3789-0.9268-3.375-4.083c-1.75-5.542,1.6514-8.1826,1-10.209c-0.375-1.166-2.334-1.125-2.334-1.125"></path> <path fill="#6A462F" stroke="none" d="M21.2813,52.125l-1.0938,2.9375c-0.625,0.2188-4.4219,1.5352-4.2812,2.7188C16.125,59.625,15,65,15,65l-2,1 c0,0-2-8-2-9c0-0.79,0-2,1-3s6-4,6-4"></path> </g> <g id="hair"></g> <g id="skin"> <path fill="#fcea2b" stroke="none" d="M46,44"></path> <path fill="#fcea2b" stroke="none" d="M48,48"></path> <circle cx="28.3857" cy="13.0625" r="2.9687" fill="#FCEA2B" stroke="none"></circle> <path fill="#FCEA2B" stroke="none" stroke-linecap="round" stroke-linejoin="round" d="M34,28l1,3l-6.7949,8l-0.0967,2.3262l4.4771,7.9387l3.1313-1.6485l-2.1381-7.9379L42,35l2-4l-8.5267-12.3163l-4.7572,0.8079l0.6382,5.9204L24,28.2188c0,0,0.8125,1.7187,1.9375,1.5312s6-0.9687,7.25-2.25L34,28z"></path> </g> <g id="skin-shadow"></g> <g id="line"> <circle cx="28.3857" cy="13.0625" r="2.9687" fill="none" stroke="#000000" stroke-miterlimit="10" stroke-width="2"></circle> <path fill="none" stroke="#000000" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2" d="M25,28l5.0771-1.4507c1.0577-0.3022,1.6758-1.4145,1.3731-2.4722l-0.9004-3.1542c-0.3027-1.0577,0.333-2.0992,1.4111-2.315 l1.0782-0.2158c1.0781-0.2158,2.4736,0.3476,3.0996,1.2524l6.7226,9.711c0.626,0.9043,0.7364,2.4492,0.2442,3.4336l-0.211,0.4218 c-0.4922,0.9844-1.6816,2.2266-2.6425,2.7608l-5.504,3.0566c-0.9609,0.5342-1.3945,1.7998-0.9628,2.8106l1.8466,4.3222 c0.4317,1.0108,0.0166,2.2891-0.9228,2.8389c-0.9404,0.5498-2.1514,0.2158-2.6914-0.7422l-2.9268-5.1894 c-0.54-0.958-0.9609-2.2657-0.9345-2.9053c0.0273-0.6397,0.6318-1.8486,1.3437-2.6875l4.2051-4.9512 C34.417,31.6855,34.7754,30.3252,34.5,29.5C34.2246,28.6748,34,28,34,28"></path> <path fill="none" stroke="#000000" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2" d="M46,44"></path> <path fill="none" stroke="#000000" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2" d="M48,48"></path> <path fill="none" stroke="#000000" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2" d="M27,35c-1-1-3.4512-4.4502-6-7c-1-1-3-2-3-2l-2-3"></path> <path fill="none" stroke="#000000" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2" d="M46,40c0,0-1,3,0,5c1.1885,2.377,5.791,8,5.791,9L49,57c0,0-1.1377,0.748-1.124,1.376C47.917,60.293,49.791,60,49.791,60 s6.3779-5.5635,6.209-6c-0.5107-1.3193-1.3672-3.7354-2-5c-1-2,4-5,4-8c0-1.6006-1-6-5-7 c-1.7246-0.4316-3.7734-0.4912-5.958-0.3486"></path> <path fill="none" stroke="#000000" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2" d="M24,64c-1.7998-0.7598-3.957-1.957-5-3c-0.3535-0.3535-0.6328-1.7354,0-3c1-2,3-6,3-6s-1.4189-0.4189-3-2c-1-1-0.8867-5.0029-1-7 c-0.1025-1.8174-2-8-2-8s-4,0-8,1c-0.6855,0.1719-2.5527-1.5576-2-2c5-4,5-4,8-6"></path> <path fill="none" stroke="#000000" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2" d="M26,61c0,0,0.5527,0.5254,1.2295,1.166c0.6758,0.6416,0.6943,1.7197,0.042,2.3965c-0.6543,0.6758-1.6563,0.8252-2.2295,0.333 C24.4688,64.4033,24,64,24,64"></path> <path fill="none" stroke="#000000" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2" d="M47,48c0,0-7.3848,3.3594-10,4c-2.4404,0.5977-9,1-9,1c-4,4-5,6-5,6s1.6289,1.3418,3,2"></path> <path fill="none" stroke="#000000" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2" d="M48,49c0,0-2.1426,6.7891-3,9c-0.4707,1.2129-0.6182,1.9219-1.542,3.958c-0.8242,1.8164-0.9101,2.1182-0.9101,2.1182 C42.2461,65.1348,42.6748,66.2246,43.5,66.5c0.8252,0.2754,1.9004-0.3066,2.3887-1.292l1.0488-2.1142"></path> <path fill="none" stroke="#000000" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2" d="M15,62v2c0,1.0996-0.6748,2-1.5,2c-0.8252,0-1.5-0.7002-1.5-1.5566c0,0,0,0,0-2.4014"></path> <path fill="none" stroke="#000000" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2" d="M18,50c0,0-5,3-6,4s-1,2.21-1,3c0,0.5176,0.4834,2.8535,1,5.042"></path> <path fill="none" stroke="#000000" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2" d="M56,35c0,0-1,0,2,0s7,3,6,7c-0.7275,2.9102-5,6,0,11"></path> <line x1="15" x2="15" y1="58" y2="62" fill="none" stroke="#000000" stroke-linecap="round" stroke-linejoin="round" stroke-miterlimit="10" stroke-width="2"></line> </g> </g></svg>   
                                 <p class="d-none d-md-inline">Cabalgata</p>
                               </button>
                             </li>
                             <li class="nav-item ocultar ${events_count_class}" role="presentation">
                               <button class="nav-link button_with_svg_icon" id="events-tab" data-toggle="tab" data-target="#events" data-form-type="events" data-action="preferences#set_form_type" type="button" role="tab" aria-controls="home" aria-selected="true">
                                 <svg viewBox="0 0 48 48" version="1" xmlns="http://www.w3.org/2000/svg" enable-background="new 0 0 48 48" fill="#000000"><g id="SVGRepo_bgCarrier1" stroke-width="0"></g><g id="SVGRepo_tracerCarrier1" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier1"> <path fill="#CFD8DC" d="M5,38V14h38v24c0,2.2-1.8,4-4,4H9C6.8,42,5,40.2,5,38z"></path> <path fill="#F44336" d="M43,10v6H5v-6c0-2.2,1.8-4,4-4h30C41.2,6,43,7.8,43,10z"></path> <g fill="#B71C1C"> <circle cx="33" cy="10" r="3"></circle> <circle cx="15" cy="10" r="3"></circle> </g> <g fill="#B0BEC5"> <path d="M33,3c-1.1,0-2,0.9-2,2v5c0,1.1,0.9,2,2,2s2-0.9,2-2V5C35,3.9,34.1,3,33,3z"></path> <path d="M15,3c-1.1,0-2,0.9-2,2v5c0,1.1,0.9,2,2,2s2-0.9,2-2V5C17,3.9,16.1,3,15,3z"></path> </g> <g fill="#90A4AE"> <rect x="13" y="20" width="4" height="4"></rect> <rect x="19" y="20" width="4" height="4"></rect> <rect x="25" y="20" width="4" height="4"></rect> <rect x="31" y="20" width="4" height="4"></rect> <rect x="13" y="26" width="4" height="4"></rect> <rect x="19" y="26" width="4" height="4"></rect> <rect x="25" y="26" width="4" height="4"></rect> <rect x="31" y="26" width="4" height="4"></rect> <rect x="13" y="32" width="4" height="4"></rect> <rect x="19" y="32" width="4" height="4"></rect> <rect x="25" y="32" width="4" height="4"></rect> <rect x="31" y="32" width="4" height="4"></rect> </g> </g></svg>
                                 <p class="d-none d-md-inline">Eventos</p>
                               </button>
                             </li>
                             <input id="search_form_type" type="hidden" value="car">
                           </ul>
                          
                             <!-- CUERPO DE LOS TAB -->
                           <div class="tab-content" id="home_form_content">
                             <!-- Formulario CAR - AUTOS -->
                             <div class="tab-pane fade show active" id="car" role="tabpanel" aria-labelledby="car-tab" data-controller="tooltip">
                               <div class="row">
                                 <div class="col-md-12">
                                   <div class="row p-0" >
                                     <div class="form-group col-12 col-sm-6 col-xl-3">
                                       <label for="car_to" data-preferences-target="textDestination"></label>
                                       <select id="car_to" class="form-control required "></select>
                                       <span class="helper-text small"></span>
                                     </div>                                
                                     <div class="form-group col-12 col-sm-6 col-xl-3">
                                       <span aria-describedby="tooltip" class="tooltip-button hide-tooltip fa fa-info-circle" data-action="mouseenter->tooltip#tooltip mouseleave->tooltip#tooltip touchstart->tooltip#tooltip touchend->tooltip#tooltip" data-tooltip="text_lugar_recogida"></span>
                                       <label for="car_collect_place" data-preferences-target="carCollectPlace" class="text-shadow">${I18n.t('histories.check_reservation.pickup_place')}</label>
                                       <select id="car_collect_place" class="form-control required box-shadow"></select>
                                       <span id="text_lugar_recogida" role="tooltip" class="text-tooltip hide-tooltip">
                                         <span class="helper-text"></span>
                                         <span id="arrow" data-popper-arrow></span>
                                       </span>
                                     </div>
                                     <div class="form-group col-12 col-sm-6 col-xl-3">
                                       <span aria-describedby="tooltip" class="tooltip-button hide-tooltip fa fa-info-circle" data-action="mouseenter->tooltip#tooltip mouseleave->tooltip#tooltip touchstart->tooltip#tooltip touchend->tooltip#tooltip" data-tooltip="text_lugar_entrega"></span>
                                       <label for="car_delivery_place" data-preferences-target="carDeliveryPlace" class="text-shadow">${I18n.t('histories.check_reservation.droppof_place')}</label>
                                       <select id="car_delivery_place" class="form-control required box-shadow"></select>
                                       <span id="text_lugar_entrega" role="tooltip" class="text-tooltip hide-tooltip">
                                         <span class="helper-text"></span>
                                         <span id="arrow" data-popper-arrow></span>
                                       </span>                                   
                                     </div>
                                     <div class="form-group col-12 col-sm-6 col-xl-3">
                                       <label for="car_category" data-preferences-target="carCategory" class="text-shadow">${I18n.t('reservation.side_bar.category')}</label>
                                       <div id="text_category" class="">
                                         <select id="car_category" class="form-control required box-shadow"></select>
                                       </div>
                                       <span class="helper-text small"></span>
                                     </div>
                                     
                                     <div class="form-group col-12 col-sm-6 col-xl-5">
                                       <label for="car_date_collect" data-preferences-target="carDateCollect" class="text-shadow">${I18n.t('reservation.side_bar.pickup_date_time')}</label>
                                       <div class="row">
                                         <div class="col-8 p-0">
                                           <input type="text" id="car_date_collect" class="form-control required box-shadow" data-action="setValue#setSessionKey" data-name="car_date_collect" data-isdate="true" readonly="readonly">
                                           <span class="helper-text small"></span>
                                         </div>
                                         <div class="col-4 mt-0 pr-0 pl-3">
                                           <input type="text" id="car_time_collect" class="form-control timepicker required box-shadow" data-action="setValue#setSessionKey" data-name="car_time_collect" data-isdate="false" readonly="readonly">
                                           <span class="helper-text small"></span>
                                         </div>
                                       </div>
                                     </div>
                                     <div class="form-group col-12 col-sm-6 col-xl-5">
                                       <label for="car_date_delivery" data-preferences-target="carDateDelivery" class="text-shadow">${I18n.t('reservation.side_bar.dropoff_date_time')}</label>
                                       <div class="row">
                                         <div class="col-8 p-0">
                                           <input type="text" id="car_date_delivery" class="form-control required box-shadow" data-action="setValue#setSessionKey" data-name="car_date_delivery" data-isdate="true" readonly="readonly">
                                           <span class="helper-text small"></span>
                                         </div>
                                         <div class="col-4 mt-0 pr-0 pl-3">
                                           <input type="text" id="car_time_delivery" class="form-control required box-shadow" data-action="setValue#setSessionKey" data-name="car_time_delivery" data-isdate="false" readonly="true">
                                           <span class="helper-text small"></span>
                                         </div>
                                       </div>
                                     </div>
                                   </div>
                                 </div>
                               </div>
                               <!-- <div class="row">-->
                               <!--   <div class="col-md-6">-->
                               <!--     <div class="form-group col-md-12">-->
                               <!--       <div class="col-md-12 m-0 p-0">-->
                               <!--         <input type="checkbox" id="has_drivers" class="">-->
                               <!--         <label for="has_drivers" data-preferences-target="manyDrivers" class="text-shadow">¿Tiene conductor adicional?</label>                -->
                               <!--         <span class="helper-text small"></span>-->
                               <!--       </div>-->
                               <!--       <div id="drivers_count" class="col-md-12  ocultar">-->
                               <!--         <label for="drivers" data-preferences-target="drivers" class="text-shadow">Cantidad de Conductores</label>-->
                               <!--         <select id="drivers" class="form-control box-shadow"></select>-->
                               <!--         <span class="helper-text small"></span>-->
                               <!--       </div>-->
                               <!--     </div>-->
                               <!--   </div>-->
                               <!--   <div class="col-md-6">-->
                               <!--     <div class="form-group col-md-12">-->
                               <!--       <input type="checkbox" id="supplement_insurance" class="">-->
                               <!--       <label for="supplement_insurance" data-preferences-target="supplementInsurance" class="text-shadow">Suplemento de Edad</label>-->
                               <!--       <span class="helper-text small"></span>-->
                               <!--     </div>-->
                               <!--   </div>-->
                               <!-- </div>-->
                               <div class="row">
                                 <div class="col-12 d-flex justify-content-end">
                                   <button id="car_btn" class="form_send ml-2" type="button" data-action="b2b#create_reservation" data-validate="car" data-addtocart="true">
                                     <span data-preferences-target="textButton" data-validate="car" data-addtocart="true"></span>
                                   </button>
                                 </div>
                               </div>
                             </div>
                             <!-- Formulario CAR - AUTOS FINNN -->
                             <div class="tab-pane fade show" id="safari" role="tabpanel" aria-labelledby="safari-tab">
                               <div class="row">
                                 <div class="col-md-12">
                                   <div class="row p-0" >
                                     <div class="form-group col-12 col-sm-6 col-md-4 col-lg-3">
                                       <label for="safari_to" data-preferences-target="textDestination">${I18n.t('reservation.side_bar.destiny')}</label>
                                       <select id="safari_to" class="form-control required "></select>
                                       <span class="helper-text small"></span>
                                     </div>                                
                                     <div class="form-group col-12 col-sm-6 col-md-4 col-lg-3">
                                       <label for="safari_modality" data-preferences-target="modality"></label>
                                       <select id="safari_modality" class="form-control required"></select>
                                       <span class="helper-text small"></span>
                                     </div>
                                
                                        <!-- EXCURSION PAX -->
                                     <div id="safari_pax_block" class="form-group col-12 col-sm-6 col-md-4 col-lg-3">
                                       <label for="safari_pax"> Pax </label>
                                       <select id="safari_pax" class="select-form c2ec_select"></select>
                                       <span class="helper-text small"></span>
                                     </div>
                                     <div id="safari_adult_childrens" class="form-group col-12 col-sm-6 col-md-4 col-lg-3 ocultar">
                                       <!-- ADULTOS Y NIÑOS -->
                                       <div class="row p-0 m-0">
                                         <div class="col p-0">
                                           <label for="safari_adultos"> ${I18n.t('reservation.side_bar.adults')} </label>
                                           <input id="safari_adultos" type="number" class="form-control" data-action="change->preferences#evaluate keyup->preferences#evaluate" value="0" data-min="0" data-max="0" data-compare="true" data-evaluate="safari_childrens" data-block="safari_btn" data-helper="safari_adult_childrens_helper">
                                         </div>
                                         <div class="col p-0">
                                           <label for="safari_childrens"> ${I18n.t('reservation.side_bar.children')} </label>
                                           <input id="safari_childrens" type="number" class="form-control" data-action="change->preferences#evaluate keyup->preferences#evaluate" value="0" data-min="0" data-max="0" data-compare="true" data-evaluate="safari_adultos" data-block="safari_btn" data-helper="safari_adult_childrens_helper">
                                         </div>
                                       </div>
                                       <span id="safari_adult_childrens_helper" class="helper-text small"></span>
                                     </div>
                                       <!-- ECURSION CANTIDAD -->
                                     <div id="safari_cantidad_block" class="form-group col-12 col-sm-6 col-md-4 col-lg-3 ocultar">
                                       <label for="safari_cantidad"> ${I18n.t('reservation.side_bar.amount')} </label>
                                       <input id="safari_cantidad" type="number" class="form-control" data-action="change->preferences#evaluate keyup->preferences#evaluate" value="0" data-min="0" data-max="0">
                                       <span class="helper-text small"></span>
                                     </div>
                                       <!-- EXCURSION FECHA -->
                                     <div class="form-group col-12 col-sm-6 col-md-4 col-lg-3">
                                       <label for="safari_date" data-preferences-target="dateCollect"></label>
                                       <input id="safari_date" type="text" class="form-control required">
                                       <span class="helper-text small"></span>
                                     </div>
                                       <!-- EXCURSION UBICACION -->
                                     <div id="excursion_location_container" class="form-group col-12 col-sm-6 col-md-4 col-lg-3 ocultar">
                                          <label for="excursion_location"> ${I18n.t('reservation.side_bar.pickup_place')}</label>
                                          <input id="excursion_location" type="text" class="form-control" placeholder="${I18n.t('reservation.side_bar.pickup_place')}" data-action="preferences#make_comment" data-text="Ubicación: ">
                                          <span class="helper-text small text-muted">${I18n.t('reservation.side_bar.pickup_place_description')}</span>
                                     </div>
                                       <!-- EXCURSION IDIOMA -->
                                     <div id="excursion_lang_container" class="form-group col-12 col-sm-6 col-md-4 col-lg-3 ocultar">
                                         <label for="excursion_lang"> ${I18n.t('reservation.side_bar.lang')}</label>
                                         <select id="excursion_lang" class="form-control"></select>
                                         <span class="helper-text small"></span>
                                     </div>
                                   </div>
                                 </div>
                               </div>
                               <div class="row">
                                 <div class="col-12 d-flex justify-content-end">
                                   <button id="safari_btn" class="form_send ml-2" type="button" data-action="b2b#create_reservation" data-validate="safari" data-addtocart="true">
                                     <span data-preferences-target="textButton" data-validate="safari" data-addtocart="true"></span>
                                   </button>
                                 </div>
                               </div>
                             </div>
                             <div class="tab-pane fade show " id="excursiones" role="tabpanel" aria-labelledby="home-tab">
                               <div class="row">
                                 <div class="col-md-12">
                                   <div class="row p-0" >
                                     <div class="form-group col-md-3">
                                       <label for="excursions_to" data-preferences-target="textDestination"></label>
                                       <select id="excursions_to" class="form-control required "></select>
                                       <span class="helper-text small"></span>
                                     </div>
                
                                     <div class="form-group col-md-3">
                                       <label for="excursions_type" data-preferences-target="category"></label>
                                       <select id="excursions_type" class="form-control required"></select>
                                       <span class="helper-text small"></span>
                                     </div>
                                
                                     <div class="form-group col-md-3">
                                       <label for="excursions_modality" data-preferences-target="modality"></label>
                                       <select id="excursions_modality" class="form-control required"></select>
                                       <span class="helper-text small"></span>
                                     </div>
                                
                                       <!-- EXCURSION PAX -->
                                     <div id="excursions_pax_block" class="form-group col-md-3">
                                       <label for="excursions_pax"> Pax </label>
                                       <select id="excursions_pax" class="select-form c2ec_select"></select>
                                       <span class="helper-text small"></span>
                                     </div>
                                     <div id="excursions_adult_childrens" class="form-group col-md-3 ocultar">
                                       <!-- ADULTOS Y NIÑOS -->
                                       <div class="row p-0 m-0">
                                         <div class="col p-0">
                                           <label for="excursions_adultos"> ${I18n.t('reservation.side_bar.adults')} </label>
                                           <input id="excursions_adultos" type="number" class="form-control" data-action="change->preferences#evaluate keyup->preferences#evaluate" value="0" data-min="0" data-max="0" data-compare="true" data-evaluate="excursion_childrens" data-block="excursion_btn" data-helper="excursion_adult_childrens_helper">
                                         </div>
                                         <div class="col p-0">
                                           <label for="excursions_childrens"> ${I18n.t('reservation.side_bar.children')} </label>
                                           <input id="excursions_childrens" type="number" class="form-control" data-action="change->preferences#evaluate keyup->preferences#evaluate" value="0" data-min="0" data-max="0" data-compare="true" data-evaluate="excursion_adultos" data-block="excursion_btn" data-helper="excursion_adult_childrens_helper">
                                         </div>
                                       </div>
                                       <span id="excursions_adult_childrens_helper" class="helper-text small"></span>
                                     </div>
                                       <!-- ECURSION CANTIDAD -->
                                     <div id="excursions_cantidad_block" class="form-group col-md-3 ocultar">
                                       <label for="excursions_cantidad"> ${I18n.t('reservation.side_bar.amount')} </label>
                                       <input id="excursions_cantidad" type="number" class="form-control" data-action="change->preferences#evaluate keyup->preferences#evaluate" value="0" data-min="0" data-max="0">
                                       <span class="helper-text small"></span>
                                     </div>
                                       <!-- EXCURSION FECHA -->
                                     <div class="form-group col-md-3">
                                       <label for="excursions_date" data-preferences-target="dateCollect"></label>
                                       <input id="excursions_date" type="text" class="form-control required">
                                       <span class="helper-text small"></span>
                                     </div>
                                       <!-- EXCURSION UBICACION -->
                                     <div id="excursions_location_container" class="form-group col-md-3 ocultar">
                                       <label for="excursions_location"> ${I18n.t('reservation.side_bar.pickup_place')}</label>
                                       <input id="excursions_location" type="text" class="form-control" placeholder="${I18n.t('reservation.side_bar.pickup_place')}" data-action="preferences#make_comment" data-text="Ubicación: ">
                                       <span class="helper-text small text-muted">${I18n.t('reservation.side_bar.pickup_place_description')}</span>
                                     </div>
                                       <!-- EXCURSION IDIOMA -->
                                     <div id="excursions_lang_container" class="form-group col-md-3 ocultar">
                                       <label for="excursions_lang"> ${I18n.t('reservation.side_bar.lang')}</label>
                                       <select id="excursions_lang" class="form-control"></select>
                                       <span class="helper-text small"></span>
                                     </div>
                                   </div>
                                 </div>
                               </div>
                               <div class="row">
                                 <div class="col-12 d-flex justify-content-end">
                                   <button id="excursions_btn" class="form_send ml-2" type="button" data-action="b2b#create_reservation" data-validate="excursiones" data-addtocart="true">
                                     <span data-preferences-target="textButton" data-validate="excursiones" data-addtocart="true"></span>
                                   </button>
                                 </div>
                               </div>
                             </div>
                             <div class="tab-pane fade show" id="rural_tourism" role="tabpanel" aria-labelledby="home-tab">
                               <div class="row">
                                 <div class="form-group col-12 col-md-6 col-lg-4">
                                   <label for="rural_tourism_to">${I18n.t('reservation.side_bar.destiny')}</label>
                                   <select id="rural_tourism_to" class="form-control required"></select>
                                   <span class="helper-text small"></span>
                                 </div>
                                 <div class="form-group col-12 col-md-6 col-lg-4">
                                   <label for="rural_tourism_service">${I18n.t('reservation.side_bar.service')}</label>
                                   <select id="rural_tourism_service" class="form-control required"></select>
                                   <span class="helper-text small"></span>
                                 </div>
                                 <div class="form-group col-12 col-md-6 col-lg-4">
                                   <!-- <label for="rural_tourism_date" data-preferences-target="dateCollect"></label>-->
                                   <label for="rural_tourism_date">${I18n.t('reservation.side_bar.date')}</label>
                                   <input id="rural_tourism_date" type="text" class="form-control required">
                                   <span class="helper-text small"></span>
                                 </div>
                                 <div class="form-group col-12 col-md-6 col-lg-4">
                                   <label for="rural_tourism_cantidad" data-preferences-target="modality">${I18n.t('reservation.side_bar.person_amount')}</label>
                                   <input type="number" id="rural_tourism_cantidad" class="form-control required" data-action="change->preferences#evaluate blur->preferences#evaluate keyup->preferences#evaluate" value="0" data-min="0" data-max="0">
                                   <span class="helper-text small"></span>
                                 </div>
                                 <div class="form-group col-12 col-lg-8">
                                   <label for="rural_tourism_observaciones">${I18n.t('histories.check_reservation.comment')}</label>
                                   <textarea id="rural_tourism_observaciones" class="form-control" name="comments" placeholder="Escriba sus observaciones aquí..." data-action="preferences#make_comment" data-text="Observaciones: "></textarea>
                                   <span class="helper-text small"></span>
                                 </div>
                               </div>
                               <div class="row">
                                 <div class="col-12 d-flex justify-content-end">
                                   <button id="rural_tourism_btn" class="form_send" type="button" data-action="b2b#create_reservation" data-validate="rural_tourism" data-addtocart="true">
                                     <span data-preferences-target="textButton" data-validate="rural_tourism" data-addtocart="true"></span>
                                   </button>
                                 </div>
                               </div>
                             </div>
                             <div class="tab-pane fade show" id="horseback_ride" role="tabpanel" aria-labelledby="home-tab">
                               <div class="row">
                                 <div class="col-md-12">
                                   <div class="row p-0" >
                                     <div class="form-group col-12 col-md-6 col-lg-4">
                                       <label for="horseback_to">${I18n.t('reservation.side_bar.destiny')}</label>
                                       <select id="horseback_to" class="form-control required"></select>
                                       <span class="helper-text small"></span>
                                     </div>
                
                                     <div class="form-group col-12 col-md-6 col-lg-4">
                                       <label for="horseback_service">${I18n.t('reservation.side_bar.service')}</label>
                                       <select id="horseback_service" class="form-control required"></select>
                                       <span class="helper-text small"></span>
                                     </div>
                                
                                     <div class="form-group col-12 col-md-6 col-lg-4">
                                       <!-- <label for="rural_tourism_date" data-preferences-target="dateCollect"></label>-->
                                       <label for="horseback_date">${I18n.t('reservation.side_bar.date')}</label>
                                       <input id="horseback_date" type="text" class="form-control required">
                                       <span class="helper-text small"></span>
                                     </div>
                                
                                     <div class="form-group col-12 col-md-6 col-lg-4">
                                       <label for="horseback_cantidad" data-preferences-target="modality">${I18n.t('reservation.side_bar.person_amount')}</label>
                                       <input type="number" id="horseback_cantidad" class="form-control required" data-action="change->preferences#evaluate blur->preferences#evaluate keyup->preferences#evaluate" data-min="0" data-max="50" data-block="horseback_ride_btn">
                                       <span class="helper-text small"></span>
                                     </div>
                                
                                     <div class="form-group col-12 col-lg-8">
                                       <label for="horseback_observaciones">${I18n.t('histories.check_reservation.comment')}</label>
                                       <textarea id="horseback_observaciones" class="form-control" name="comments" placeholder="Escriba sus observaciones aquí..." data-action="preferences#make_comment" data-text="Observaciones: "></textarea>
                                       <span class="helper-text small"></span>
                                     </div>
                                   </div>
                                 </div>
                                 <div class="col-md-12 p-0">
                                   <div class="d-flex justify-content-end" style="padding: 15px 0;width: 100%;">
                                     <button id="horseback_ride_btn" class="form_send" type="button" data-action="b2b#create_reservation" data-validate="horseback_ride" data-addtocart="true">
                                       <span data-preferences-target="textButton" data-validate="horseback_ride" data-addtocart="true"></span>
                                     </button>
                                   </div>
                                 </div>
                               </div>
                             </div>

                             <div class="tab-pane fade show" id="events" role="tabpanel" aria-labelledby="home-tab">
                               <div class="row">
                                 <div class="form-group col-12 col-md-6 col-lg-4">
                                   <label for="event_product">Grupo</label>
                                   <select id="event_product" class="form-control required"></select>
                                   <span class="helper-text small"></span>
                                 </div>
                                 <div class="form-group col-12 col-md-6 col-lg-4">
                                   <label for="event_modality">Modalidad</label>
                                   <select id="event_modality" class="form-control required"></select>
                                   <span class="helper-text small"></span>
                                 </div>
<!--                                 <div class="form-group col-12 col-md-6 col-lg-4">-->
<!--                                   <label for="event_category_person">Categoría</label>-->
<!--                                   <select id="event_category_person" class="form-control required"></select>-->
<!--                                   <span class="helper-text small"></span>-->
<!--                                 </div>-->
<!--                                 <div class="form-group col-12 col-md-6 col-lg-4 ocultar">-->
<!--                                   <label for="event_entity">Nombre de entidad</label>-->
<!--                                   <input id="event_entity" class="form-control" type="text">-->
<!--                                   <span class="helper-text small"></span>-->
<!--                                 </div>-->
                                 <div class="form-group col-12 col-md-6 col-lg-4">
                                   <label for="event_amount">Cantidad de habitaciones</label>
                                   <input id="event_amount" class="form-control required" type="number">
                                   <span class="helper-text small"></span>
                                 </div>
                                 <div class="form-group col-12 col-md-6 col-lg-4">
                                   <label for="event_pax">Cantidad de personas</label>
                                   <input id="event_pax" class="form-control required" type="number">
                                   <span class="helper-text small"></span>
                                 </div>
                                 
                                 <div class="col-md-12 p-0">
                                   <div class="d-flex justify-content-end" style="padding: 15px 0;width: 100%;">
                                     <button id="event_btn" class="form_send" type="button" data-action="b2b#create_reservation" data-validate="events" data-addtocart="true">
                                       <span data-preferences-target="textButton" data-validate="events" data-addtocart="true"></span>
                                     </button>
                                   </div>
                                 </div>
                               </div>
                             </div>
                             
                           </div>
                         </div>
                       </div>
                     </div>
                   </div>
                 </div>
                `;
                break;
            case 'presentation-information':
                html += ` <div class="presentation-information">
                              <div class="presentation-header">
                                <div class="header-helper">
                                    ${helpertext || ''}
                                </div>
                                <div class="header-image" >
                                      <img src="${picture}" alt="">
                                </div>
                              </div>
                              <div class="presentation-body">
                                <div class="title">${name}</div>
                                <div class="divider"></div>
                                <div class="content">${description}</div>
                              </div>
                            </div>`
                break;
            case 'presentation-modalities-list':
                /*html += `<div class="presentation-modalities-list" style="--picture: url(${picture})">
                              <div class="presentation-container">
                                <div class="presentation-left">
                                  <div class="helper">${helpertext}</div>
                                  <div class="square"></div>
                                </div>
                                <div class="presentation-right">
                                  <div class="title">${name}</div>
                                  <div id="section_${id}" class="page-list"></div>
                                </div>
                              </div>
                              <div class="presentation-bottom-image">
                                <img src="${divider_bottom}" alt="">
                              </div>
                            </div>`*/
                /*html += `<div class="presentation-modalities-list" style="--picture: url(${picture}); height: 100% !important;">
                              <div class="presentation-container">
                                <div class="presentation-all-services">
                                  <div id="section_${id}" class="page-list row" style="color: black;">
                                    <div class="col-12" style="margin-bottom: 1rem;top: -2rem;">
                                      <h3 class="card-title" style="color: white;text-align: center;font-size: 2rem;">${helpertext} <b>${name}</b> </h3>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div class="presentation-bottom-image">
                                <img src="${divider_bottom}" alt="">
                              </div>
                            </div>`*/

                /*<div class="presentation-bottom-image" style="width: 100%; height: 100%;">
                    <img src="${picture}" alt="" style="width: 100%; height: 100%;">
                </div>*/
                html += `<div class="presentation-modalities-list">
                           <div class="presentation-container">
                             <div class="presentation-all-services">
                               <div class="presentation-title" >${helpertext} ${name} </div>
                               <div id="section_${id}" class="page-list row">
                               </div>
                             </div>
                           </div>
                         </div>`
                break;
            case 'presentation-notice-more-events':
                /* <div class="presentation-header">
                        <div class="side-left">
                          <div class="title">${name}</div>
                          <div class="divider"></div>
                          <div class="helper">${helpertext}</div>
                        </div>
                        <div class="side-right">
                          <div class="background">
                            <img src="${bg_image}" alt="">
                          </div>
                          <div class="thumbnail">
                            <img src="${picture}" alt="">
                          </div>
                        </div>
                      </div> */
                html += `
                  <div class="presentation-notice-more-events" data-controller="tooltip">
                      <!-- Va Aquí -->
                      <div class="presentation-body">
                        <div id="event_container" class="events">
                          <div class="title">${I18n.t('global.section_an_page.events')}</div>
                          <!-- <div id="events" class="carousel slide" data-ride="carousel" data-interval="false" data-pause="hover" data-touch="true"> -->
                          <div id="events" class="carousel slide" data-ride="carousel" data-interval="false" data-touch="true">
                            <div id="event_page_${id}" class="carousel-inner pages" style="padding: 25px 5% !important;">
                             
                            </div>
                            <button class="carousel-control-prev event-control" type="button" data-target="#events" data-slide="prev">
                              <span class="fa fa-arrow-left" aria-hidden="true"></span>
                            </button>
                            <button class="carousel-control-next event-control" type="button" data-target="#events" data-slide="next">
                              <span class="fa fa-arrow-right" aria-hidden="true"></span>
                            </button>
                            <div class="swipe-btn d-md-none">
                              <span aria-describedby="tooltip" class="tooltip-button" data-action="mouseenter->tooltip#tooltip mouseleave->tooltip#tooltip touchstart->tooltip#tooltip touchend->tooltip#tooltip" data-tooltip="swipe_button">
                                <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-hand-move" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                                     <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                                     <path d="M8 13v-8.5a1.5 1.5 0 0 1 3 0v7.5"></path>
                                     <path d="M11 11.5v-2a1.5 1.5 0 0 1 3 0v2.5"></path>
                                     <path d="M14 10.5a1.5 1.5 0 0 1 3 0v1.5"></path>
                                     <path d="M17 11.5a1.5 1.5 0 0 1 3 0v4.5a6 6 0 0 1 -6 6h-2h.208a6 6 0 0 1 -5.012 -2.7l-.196 -.3c-.312 -.479 -1.407 -2.388 -3.286 -5.728a1.5 1.5 0 0 1 .536 -2.022a1.867 1.867 0 0 1 2.28 .28l1.47 1.47"></path>
                                     <path d="M2.541 5.594a13.487 13.487 0 0 1 2.46 -1.427"></path>
                                     <path d="M14 3.458c1.32 .354 2.558 .902 3.685 1.612"></path>
                                  </svg>
                              </span>
                              <span id="swipe_button" role="tooltip" class="text-tooltip hide-tooltip" style="font-size: .85em; width: 250px !important; padding: 20px; text-align: start;background: var(--txt-highlight-secondary) !important;box-shadow: 0 0 25px rgba(0,0,0,.5);">
                                   <span class="helper-text">Puede desplazar la pantalla a la izquierda o la derecha para ver más noticias o eventos</span>
                                   <span id="arrow" data-popper-arrow></span>
                                </span>
                            </div>
                          </div>
                        </div>
                        <div id="notice_container" class="notices">
                          <div class="title">${I18n.t('global.section_an_page.notices')}</div>
                          <div id="notices" class="carousel slide" data-ride="carousel" data-interval="false" data-touch="true">
                            <div id="notice_page_${id}" class="carousel-inner pages" style="padding: 25px 5% !important;">
                              
                            </div>
                            <button class="carousel-control-prev notice-control" type="button" data-target="#notices" data-slide="prev">
                              <span class="fa fa-arrow-left" aria-hidden="true"></span>
                            </button>
                            <button class="carousel-control-next notice-control" type="button" data-target="#notices" data-slide="next">
                              <span class="fa fa-arrow-right" aria-hidden="true"></span>
                            </button>
                            <div class="swipe-btn d-md-none">
                              <span aria-describedby="tooltip" class="tooltip-button" data-action="mouseenter->tooltip#tooltip mouseleave->tooltip#tooltip touchstart->tooltip#tooltip touchend->tooltip#tooltip" data-tooltip="swipe_button_notices">
                                  <svg xmlns="http://www.w3.org/2000/svg" class="icon icon-tabler icon-tabler-hand-move" width="24" height="24" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor" fill="none" stroke-linecap="round" stroke-linejoin="round">
                                    <path stroke="none" d="M0 0h24v24H0z" fill="none"></path>
                                    <path d="M8 13v-8.5a1.5 1.5 0 0 1 3 0v7.5"></path>
                                    <path d="M11 11.5v-2a1.5 1.5 0 0 1 3 0v2.5"></path>
                                    <path d="M14 10.5a1.5 1.5 0 0 1 3 0v1.5"></path>
                                    <path d="M17 11.5a1.5 1.5 0 0 1 3 0v4.5a6 6 0 0 1 -6 6h-2h.208a6 6 0 0 1 -5.012 -2.7l-.196 -.3c-.312 -.479 -1.407 -2.388 -3.286 -5.728a1.5 1.5 0 0 1 .536 -2.022a1.867 1.867 0 0 1 2.28 .28l1.47 1.47"></path>
                                    <path d="M2.541 5.594a13.487 13.487 0 0 1 2.46 -1.427"></path>
                                    <path d="M14 3.458c1.32 .354 2.558 .902 3.685 1.612"></path>
                                  </svg>
                              </span>
                    
                              <span id="swipe_button_notices" role="tooltip" class="text-tooltip hide-tooltip" style="font-size: .85em; width: 250px !important; padding: 20px; text-align: start;background: var(--txt-highlight-secondary) !important;box-shadow: 0 0 25px rgba(0,0,0,.5);">
                                   <span class="helper-text">Puede desplazar la pantalla a la izquierda o la derecha para ver más noticias o eventos</span>
                                   <span id="arrow" data-popper-arrow></span>
                                </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                `;
                break;
            case 'presentation-with-image-for-page':
                if (has_divider_top) {
                    dt = `<div class="col-md-12 presentation-divider-top" style="--img-dv-top: url(${divider_top})"></div>`;
                }

                html += `
                <div class="col-md-12 presentation-with-image-for-page">
                    <div class="row">
                        ${dt}
                    </div>
               
                    <div class="row">
                      <div class="col-md-12">
                        <div class="presentation-title last-word-change">
                          ${name}
                        </div>
                      </div>
                    </div>
                    <div id="section_${id}" class="pages-wrapper"></div>
                    <div class="presentation-footer">
                      <a onclick="location.href = '/${sessionStorage.getItem('locale')}/sections/ver/${url}'" class="btn-presentation-footer">
                        ${I18n.t('main.body.read_more')}
                      </a>
                    </div>
                  </div>
                `
                break;
            case 'presentation_with_image_left':
                if (has_divider_top) {
                    margin_y = 'margin-y'
                    dt = `<div class="presentation-divider"><div class="presentation-divider-top" style="--img-dv-top: url(${divider_top})"></div></div>`;
                }
                html += `
                <div class="col-md-12">
                  <div class="presentation-with-image-left">
                    ${dt}
                    <div class="wrapper ${margin_y}">
                        <div class="image-container">
                      
                        <img src="${picture}" alt="${name}">
                        </div>
                        <div class="info-container">
                        <div class="helper-text">
                        ${helpertext}
                        </div>
                        <div class="title-text last-word-change">
                        ${name}
                        </div>
                        <div class="divider"></div>
                        <div class="description-text">
                        ${description}
                        </div>
                        <div class="button_action">
                            <button onclick="location.href = '/${sessionStorage.getItem('locale')}/sections/ver/${url}'"> ${I18n.t('global.main.read_more')}</button>
                        </div>
                        </div>
                        <div class="page-wrapper">
                            <div class="divider-vertical"></div>
                            <div class="">
                        <ul id="section_${id}" class="pages"></ul>
                        </div>
                        </div>
                    </div>
                  </div>
                </div>
                `;
                break;
            case 'presentation_with_image_5_columns':
                if (has_divider_top) {
                    margin_y = 'margin-y'
                    dt = `<div class="presentation-divider"><div class="presentation-divider-top" style="--img-dv-top: url(${divider_top})"></div></div>`;
                }
                html += `
                <div class="col-md-12">
                  <div class="presentation-with-pages-by-column">
                   ${dt}
                   <div class="wrapper ${margin_y}">
                        <div class="presentation-title">
                          <div class="presentation-text last-word-change"> ${name}</div>
                          <div class="divider"></div>
                          <div class="presentation-helper"> ${helpertext}</div>
                        </div>
                       
                        <div id="section_${id}" class="presentation-body slick-five-column">
                        </div>
                    </div>
                  </div>
                </div>
                `;
                break;
            case 'presentation_with_image_3_columns':
                if (has_divider_top) {
                    margin_y = 'margin-y'
                    dt = `<div class="presentation-divider"><div class="presentation-divider-top" style="--img-dv-top: url(${divider_top})"></div></div>`;
                }
                html += `
                 <div class="col-md-12 ">
                  <div class="presentation_with_image_3_columns">
                  ${dt}
                   <div class="wrapper ${margin_y}">
                        <div class="presentation-title">
                          <div class="presentation-text last-word-change" > ${name}</div>
                          <div class="divider"></div>
                           <div class="presentation-helper" > ${helpertext}</div>
                        </div>
                        <div id="section_${id}" class="presentation-body slick-three-column"></div>
                    </div>
                  </div>
                </div>
                `;
                break;
            case 'presentation-whit-image-right':
                if (has_divider_top) {
                    margin_y = 'margin-y'
                    dt = `<div class="presentation-divider"><div class="presentation-divider-top" style="--img-dv-top: url(${divider_top})"></div></div>`;
                }

                html += `<span id="section_${id}_textname" class="ocultar">${name}</span>`;
                if (window.innerWidth <= 640) {
                    html += `
                <div class="col-md-12">
                  <div class="presentation-whit-image-right">
                  ${dt}
                  <div class="wrapper ${margin_y}">
                    <div class="page-container">
                      <div class="page-header last-word-zoom" data-target="text_section_${id}" data-source="section_${id}_textname">${name}</div>
                      <div class="divider"></div>
                       <div class="image-container">
                      <div id="text_section_${id}" class="text-extra"></div>
                         <div class="image-wrapper">
                              <img src="${picture}" alt="${name}">
                            </div>
                        </div>
                      <div class="page-helper-text">${helpertext}</div>
                      <div class="page-wrapper">
                        <ul id="section_${id}" class="page-list">
            
                        </ul>
                      </div> 
                      <div class="page-buttons">
                        <button onclick="location.href =location.origin+'/${sessionStorage.getItem('locale')}/sections/ver/${url}'">${I18n.t('global.main.read_more')}</button>
                      </div>
                    </div>
                   </div>
                  </div>
                </div>
                `;
                } else {
                    html += `
                <div class="col-md-12">
                  <div class="presentation-whit-image-right">
                  ${dt}
                  <div class="wrapper ${margin_y}">
                  <div class="page-container">
                      <div class="page-header last-word-zoom" data-target="text_section_${id}" data-source="section_${id}_textname">${name}</div>
                      <div class="divider"></div>
                      <div class="page-helper-text">${helpertext}</div>
                      <div class="page-wrapper">
                        <ul id="section_${id}" class="page-list">
            
                        </ul>
                      </div> 
                      <div class="page-buttons">
                       <button onclick="location.href =location.origin+'/${sessionStorage.getItem('locale')}/sections/ver/${url}'">${I18n.t('global.main.read_more')}</button>
                      </div>
                    </div>
                    <div class="image-container">
                      <div id="text_section_${id}" class="text-extra"></div>
                         <div class="image-wrapper">
                              <img src="${picture}" alt="${name}">
                            </div>
                        </div>
                    </div>
                    
                  </div>
                </div>
                `;
                }
                break;
            case 'presentation_with_image_2_columns':
                if (has_divider_top) {
                    margin_y = 'margin-y'
                    dt = `<div class="presentation-divider"><div class="presentation-divider-top" style="--img-dv-top: url(${divider_top})"></div></div>`;
                }
                html += `
                 <div class="col-md-12 section">
                  <div class="presentation_with_image_2_columns">
                   ${dt}
                    <div id="section_${id}" class="page-container ${margin_y}">
                    </div>
                  </div>
                </div>
                `;
                break;
            case 'presentation-paralax-with-3-columns':
                if (has_divider_top) {
                    margin_y = 'margin-y'
                    dt = `<div class="presentation-divider"><div class="presentation-divider-top" style="--img-dv-top: url(${divider_top})"></div></div>`;
                }

                if (has_divider_bottom) {
                    db = `<div class="presentation-divider-bottom"><div class="presentation-divider-bottom" style="--img-dv-top: url(${divider_bottom})"></div></div>`;
                }
                html += `
                 <div class="col-md-12 ">
                  <div class="presentation-paralax-with-3-columns">
                    ${dt}
                    <div class="wrapper">
                         <div class="backgroud-paralax" style="background-image: url('${picture}');">
                          <div class="presentation-wrapper ${margin_y}">
                            <div class="presentation-helper-text">${helpertext}</div>
                            <div class="presentation-header">
                              ${name}
                            </div>
                            <div class="presentation-description">
                              <div class="description-text">
                                ${description}
                              </div>
                            </div>
                            <div id="section_${id}" class="presentation-pages"></div>
                          </div>
                        </div>          
                    </div>
                   ${db}
                  </div>       
                </div>
                `;
                break;
            case 'presentation-with-notice':
                if (has_divider_top) {
                    margin_y = 'margin-y'
                    dt = `<div class="presentation-divider"><div class="presentation-divider-top" style="--img-dv-top: url(${divider_top})"></div></div>`;
                }
                html += `
                   <div class="col-md-12 section">
                    <div class="presentation-with-notice">
                         ${dt}
                      <div class="notice-container ${margin_y}">
                      <div class="notice-header">
                        <div class="notice-title last-word-change">${name}</div>
                        <div class="notice-divider"></div>
                        <div class="notice-helper-text">${helpertext}</div>
                      </div>
                        <div class="notice-body">
                         <div id="section_${id}" class="notice-list slick_notice"></div>
                        </div>
                      </div>
                    </div>
                  </div>
                `;
                break;
            case 'presentation-comercial-client':
                html += `
                        <div class="container-fluid">
                          <div class="presentation-comercial-client">
                            <div class="presentation-title col-12 col-md-12">
                              <div class="presentation-text last-word-change" data-controller="word">
                                ${name}
                              </div>
                              <div class="mb-3">
                                ${helpertext}
                              </div>
                              <div class="divider"></div>
                            </div>
                            <div id="section_${id}" class="presentation-body row"></div>
                          </div>
                        </div>
                `;
                break;
            case 'presentation-with-map':
                map_section_id = id;
                html += `
                       <div class="presentation-with-map">
                          <div class="left">
                            <div id="overlay_map_load" class="overlay_map_load_left"></div>
                            <div class="for_map" data-controller="map">
                              <div id="map" data-id="${id}"></div>
                            </div>
                          </div>
                          <div class="right">
                            <div class="title">${name}</div>
                            <div class="divider"></div>
                            <div class="helper">${helpertext}</div>
                          </div>
                        </div>
                `;
                break;
            case 'presentation-review':
                review_section_id = id;
                review_section = `section_${id}`;

                html += `
                <div id="review_pre" class="presentation-review">
                  <div class="background" style="--picture: url(${picture})">
                
                  </div>
                  <div class="presentation-body">
                    <div class="title">${name}</div>
                    <div class="body" data-controller="carousel">
                      <div id="review" class="carousel slide carousel-fade modifi_behavior_carousel" data-ride="carousel" data-interval="false" data-touch="true">
                        <div id="section_${id}" class="carousel-inner"></div>
                        <button class="carousel-control-prev" type="button" data-target="#review" data-slide="prev">
                            <span class="fa fa-arrow-left" aria-hidden="true"></span>
                          </button>
                          <button class="carousel-control-next" type="button" data-target="#review" data-slide="next">
                            <span class="fa fa-arrow-right" aria-hidden="true"></span>
                          </button>

                      </div>
                    </div>
                  </div>
                  <div class="bottom">
                   <img src="${divider_bottom}" alt="">
                  </div>
                </div>
                `;
                break;
            case 'presentation-gallery':
                section_gallery = id;

                html += `
                <div id="presentation_gallery_${id}" class="presentation-gallery">
                  <div class="row">
                    <div class="col-12 col-md-4" >
                      <div class="visor-image">
                        <div class="title">${name}</div>
                        <div class="helper-text">
                          ${helpertext}
                        </div>
                      </div>
                    </div>
                    <div class="col-12 col-md-8">
                      <div id="presentation_magic_masonry_${id}" class="carousel slide carousel-fade" data-ride="carousel" data-touch="true" data-interval="false">
                        <div id="section_${id}" class="carousel-inner">
                         
                        </div>
                        <div id="button_magic_masonry_${id}">
                        <button class="carousel-control-prev" type="button" data-target="#presentation_magic_masonry_${id}" data-slide="prev">
                          <span class="fa fa-arrow-left"></span>
                        </button>
                        <button class="carousel-control-next" type="button" data-target="#presentation_magic_masonry_${id}" data-slide="next">
                          <span class="fa fa-arrow-right"></span>
                        </button>
                        </div>
                      </div>
                
                    </div>
                  </div>
                </div>
                `;
                break;
        }

        html += `</div></section>`;

        return html;
    }

    tpl_section_footer(id, url, name, type) {
        let html = ``;
        switch (type) {
            case 'footer':
                html += `
                   <div class="footer-section">
                    <div class="footer-section-title">
                      ${name}
                    </div>
                    <div id="section_${id}" class="section-page-wrapper">
                    </div>
                  </div>
                `;
                break;
        }
        return html;
    }

    tpl_page(id, url, isExternal, name, description, type, picture, icon, count = 0, has_div_top = false, div_top = '', has_dv_bottom = false, dv_bottom = '', show_more_page) {
        let des = description || ' ';
        let html = ``;
        let dt = '';
        let db = '';

        switch (type) {
            case 'presentation-with-image-for-page':
                let aa_ifp = 'javascript:;';
                if (show_more_page) {
                    aa_ifp = url;
                }
                html += `
                 <div class="page-item">
                   ${dt}
                   <a href="${aa_ifp}">
                     <div class="image-page">
                       <img src="${picture}">
                     </div>
                     <div class="text-page">
                       ${name}
                     </div>
                   </a>
                   ${db}
                 </div>`;
                break;
            case 'presentation-modalities-list':
                let aa_mod_list = 'javascript:;';
                if (show_more_page) {
                    aa_mod_list = url;
                }
                /*html = `<a href="${url}" class="page">
                          <span class="icon">
                            ${icon}
                          </span>
                          <span class="page-name">${name}</span>
                        </a>`;*/
                /*html = `<div class="col-md-6 col-xl-4 page d-flex" style="margin-bottom: 1rem">
                          <div class="card h-100 w-100" style="min-height: 15rem;">
                            <div class="card-body d-flex align-items-center p-0 overflow-hidden">
                              <!-- Imagen - 35% del ancho -->
                              <div class="d-flex align-items-center justify-content-center bg-light" style="width: 95%; height: 100%;">
                                ${icon}
                              </div>
                              <!-- Contenido textual - 65% del ancho -->
                              <div class="p-3 w-100">
                                <h5 class="card-title mb-2">${name}</h5>
                                <p class="card-text mb-3" style="font-size: 0.9rem; overflow: scroll; max-height: 8rem;">
                                  ${description}
                                </p>
                                <a href="#" class="btn btn-primary btn-sm d-block">Go somewhere</a>
                              </div>
                            </div>
                          </div>
                        </div>`;*/
                html = `<div class="card">
                          <a id="card_page_url" href="${url}">
                            <div class="card-body d-flex flex-column justify-content-between align-items-center p-0 overflow-hidden">
                              <div class="card-img">
                                <img class="" src="${picture}" alt="${name}" width="375" height="500">
                              </div>
                              <!-- Contenido textual - 65% del ancho -->
                              <div class="card-container p-3 w-100">
                                <h5 class="card-title mb-2">${name}</h5>
                                <p class="card-text mb-3" style="display: none;">
                                  ${description}
                                </p>
                                <!-- <a href="${url}" class="card-buttons btn btn-primary btn-sm d-block">Ir a la página</a>-->
                                <span class="card-buttons btn btn-primary btn-sm" style="display: none;">Ir a la página</span>
                              </div>
                            </div>
                          </a>
                        </div>`;
                break;
            case 'presentation-notice-more-events':
                /*let active = '';
                if (count === 0) {
                    active = 'active';
                }*/

                let aa_n_e = '';
                if (show_more_page) {
                    aa_n_e = `<a class="a-link" href="${url}">${I18n.t('main.body.read_more')}</a>`;
                }
                // <div  class="carousel-item ${active}">
                html += `
                        <div class="page">
                            <div class="left">
                                <img src="${picture}" alt="">
                                ${aa_n_e}
                            </div>
                        <div class="right">
                            <div class="title">${name}</div>
                                <div class="helper">${description}</div>
                            </div>
                        </div>
                    `;
                // </div>
                break;
            case 'presentation_with_image_left':
                html = `
                    <li class="page-section">
                      <div class="page-icon">
                        ${icon}
                      </div>
                      <div class="page-container">
                        <div class="page-title">
                          ${name}
                        </div>
                        <div class="divider"></div>
                        <div class="page-body">
                          ${des}
                        </div>
                     </div>
                    </li>`;
                break;
            case 'presentation_with_image_5_columns':
                let aa_5 = '';
                if (show_more_page) {
                    aa_5 = `<div class="page-buttons">
                              <button onclick="location.href = '${url}'">${I18n.t('global.main.read_more')}</button>
                            </div>`;
                }
                html = `<div class="">
                          ${dt}
                          <div class="page-card">
                            <div class="page-slider">
                              <div class="page-card-image">
                                <img src="${picture}" alt="${name}">
                              </div>
                              <div class="page-card-body">
                                <div class="page-title">
                                  ${name}
                                </div>
                                <div class="page-divider"></div>
                                <div class="page-helper">
                                  ${description}
                                </div>
                                ${aa_5}
                              </div>
                            </div>
                          </div>
                        </div>
                        ${db}
                        </div>`;
                break;
            case 'presentation_with_image_3_columns':
                let aa_3 = 'javascript:;';
                if (show_more_page) {
                    aa_3 = url;
                }
                html = ` 
                 <div class="">
                  ${dt}
                 <div class="page-card">
                                  <div class="page-slider">
                                    <div class="page-card-image">
                                      <img src="${picture}" alt="${name}" onclick="location.href = '${url}'">
                                    </div>
                                    <div class="page-title">
                                      ${name}
                                    </div>
                                    <div class="page-divider"></div>
                                  </div>
                                </div>
                                 ${db}
                </div>
                 `;
                break;
            case 'presentation-whit-image-right':
                html = ` <li>
                    <div class="page-icon">
                      ${icon}
                    </div>
                    <div class="page-container">
                      <div class="page-title">${name}</div>
                      <div class="divider-page"></div>
                    </div>
                  </li>`;
                break;
            case 'presentation_with_image_2_columns':
                let aa_2 = '';
                if (show_more_page) {
                    aa_2 = `<button onclick="location.href = '${url}'">${I18n.t('global.main.read_more')}</button>`;
                }
                let text = des.slice(0, 250);
                html = ` <div class="page">
                ${dt}
                <div class="page-image-container">
                <div class="overlay"></div>
                  <img src="${picture}" alt="${name}">
                </div>
                <div class="page-body-container">
                  <div class="body-header">${name}</div>
                  <div class="body-text">${text}...</div>
                  <div class="body-button">
                    ${aa_2}
                  </div>
                </div>
                 ${db}
              </div>`;
                break;
            case 'presentation-paralax-with-3-columns':
                let aa_paralax_3 = 'javascript:;';
                if (show_more_page) {
                    aa_paralax_3 = url;
                }
                html = `
                  <div class="page">
                    <button onclick="location.href = '${aa_paralax_3}'">${name}</button>
                  </div>
                `;
                break;
            case 'presentation-with-notice':
                let aa_n = '';
                if (show_more_page) {
                    aa_n = `<button type="button" onclick="location.href = '${url}'">${I18n.t('global.main.read_more')}</button>`;
                }
                html += `
                    <div class="">
                     ${dt}
                     <div class="notice">
                        <div class="n-picture">
                          <img src="${picture}" alt="${name}">
                        </div>
                        <div class="n-divider"></div>
                        <div class="n-wrapper">
                        <div class="n-title">
                          ${name}
                        </div>               
                        <div class="n-body">
                          ${des}
                        </div>
                        <div class="n-footer">
                          ${aa_n}
                        </div>   
                        </div>       
                      </div>
                       ${db}
                    </div>
                `;
                break;
            case 'presentation-comercial-client':
                html += `<div class="col-6 col-sm-6 col-md-4 col-lg-2 mb-5">
                           <div class="card-comercial">
                             <div class="image-container">
                               <img src="${picture}" alt="${name}">
                             </div>
                             <div class="image-text d-flex justify-content-center">
                               <div class="divider"></div>
                             </div>
                           </div>
                         </div>`;
                break;
        }

        return html;
    }

    tpl_catalog(id, category, category_id, picture, price, description, showButton) {
        let buyBtn = '';
        let btn_text = I18n.t('main.body.catalog.rent_btn');
        if (showButton) {
            buyBtn = `<a href="javascript:;" class="buy-btn" data-action="setValue#pre_reservation" data-id="${id}"   data-category="${category}" data-categoryid="${category_id}" data-description="${description}"  >${btn_text}</a>`;
        }
        return `<div class="">
                  <div class="box">
                    <div class="slider-img">
                      <img src="${picture}" alt="${category}">
                      <div class="overlay">
                        ${buyBtn}
                      </div>
                    </div>
                    <div class="detail-btn">
                      ${buyBtn}
                    </div>
                    <div class="details-box">
                      <div class="type">
                        <a href=""></a>
                        <span>${category}</span>
                      </div>
                      <a href="" class="price">
                        ${I18n.t('main.body.catalog.from')} $${price}.00
                      </a>
                    </div>
                    <div class="detail-description">
                      <div class="title-description">
                        ${I18n.t('main.body.catalog.description')}
                      </div>
                      <div class="desciption-body">
                        ${description}
                      </div>
                    </div>
                  </div>
                </div>`;
    }

    tpl_page_footer(id, url, isExternal = false, name, icon = null, show_more_page) {
        let html = '';

        if (icon !== null && icon.includes('fa')) {
            icon = `fa ${icon}`;
        }

        let url_show_more_page = 'javascript:;';
        if (show_more_page) {
            url_show_more_page = url;
        }


        if (isExternal) {
            html = `<div class="footer-link">
                      <a href="${url_show_more_page}" target="_blank">${icon} ${name}</a>
                    </div>`;
        } else {
            html = `<div class="footer-link">
                      <a href="${url_show_more_page}" >${icon} ${name}</a>
                    </div>`;
        }
        return html
    }

    print(e) {
        set_locale().then(
            locale => {
                location.href = location.origin + `/${locale.locale}/histories/${e.target.dataset.history}.pdf`
            }
        )
    }

    pre_reservation(e) {
        save_data_pre_reservation(e.target).then(r => {
                if (r.fail_count === 0) {
                    location.href = `/${sessionStorage.getItem('locale')}/pre_reservation`;
                }
            }
        );
    }

    cancel_reservation() {
        get_popup('cancel_rent').then(
            cancel_rent => {
                Swal.fire({
                    title: cancel_rent.title || 'Cancelar reserva',
                    text: cancel_rent.description || "¿Usted desea cancelar su reserva?",
                    icon: cancel_rent.icon || 'question',
                    showCancelButton: true,
                    confirmButtonText: I18n.t('global.popup.cancel_rent_confirm'),
                    cancelButtonText: I18n.t('global.popup.cancel_rent_cancel'),
                    reverseButtons: true,
                    allowOutsideClick: false,
                    // backdrop: `#354052`,
                    backdrop: `rgba(255, 255, 255, 1)`,
                    customClass: {
                        confirmButton: 'btn btn-secondary',
                        cancelButton: 'btn btn-success margin-right-15'
                    },
                    buttonsStyling: false
                })
                    .then(async (result) => {
                        blockBody();
                        if (result.isConfirmed) {
                            await cancelReservation();
                        }
                        if (result.isDismissed) {
                            location.href = `/${sessionStorage.getItem('locale')}/reserva`
                        }
                    })
            }
        )
    }

    hide_reservation() {
        let r = $('#reservation');
        r.removeClass('show_reservation');
        r.addClass('hidde_reservation')
    }

    show_hide_element(e) {
        let hide = $('#' + e.target.dataset.hide);
        let show = $('#' + e.target.dataset.show);

        hide.addClass('ocultar');
        show.removeClass('ocultar');
    }

    assistan_line(e) {
        let url = location.origin + `/${sessionStorage.getItem('locale')}/help_me`;
        if (localStorage.hasOwnProperty('chat_room')) {
            url = location.origin + `/${sessionStorage.getItem('locale')}/help_me?id=` + sessionStorage.getItem('chat_room');
        }

        location.href = url;
    }

    saltarA(e) {
        let element = $(e.target.dataset.target);
        let top = parseFloat(element.offset().top) - 87;
        $("html, body").animate({scrollTop: top}, 1000);
    }

    actionTrigger(e) {
        $(`#button_toogle_menu_bar`).trigger('click');
        $(`#button_toogle_page_filter`).trigger('click');
    }

    clear_session(e) {
        alert('Vamos a limpiar la section');
        setSessionVar('', '', 'clear', false).then(
            clear => {
                location.href = location.origin
            }
        )
    }
}